import { jsxs as s, jsx as r, Fragment as C } from "react/jsx-runtime";
import { useMemo as Ke, useEffect as le, useState as _, useContext as ce, createContext as de, useRef as E, useLayoutEffect as Xe, Fragment as se, useReducer as Je } from "react";
import i, { createGlobalStyle as Qe, ThemeProvider as Ze, keyframes as V } from "styled-components";
import { OpenInNew as er } from "@styled-icons/material-outlined/OpenInNew";
import rr from "reactjs-popup";
import { Person as tr } from "@styled-icons/material/Person";
import "reactjs-popup/dist/index.css";
import { ClickdepagoIso as pe, ClickdepagoLogo as he, NoDataIcon as or } from "@increasecard/icons";
import { ArrowDropDown as j } from "@styled-icons/material/ArrowDropDown";
import { ArrowDropUp as nr } from "@styled-icons/material/ArrowDropUp";
import P from "date-fns/locale/es";
import { format as w, formatDistance as ir, parseISO as ge, parse as re } from "date-fns";
import { Notifications as ar } from "@styled-icons/material/Notifications";
import { NotificationsActive as lr } from "@styled-icons/material/NotificationsActive";
import cr from "react-dom";
import { Menu as dr } from "@styled-icons/material-outlined/Menu";
import { Close as sr, Done as H, Info as pr, Email as hr, ChevronLeft as ue, ChevronRight as me, Event as fe } from "@styled-icons/material-outlined";
import { Cancel as gr, VisibilityOff as ur, Visibility as mr, Close as U } from "@styled-icons/material";
import fr from "react-calendar";
import G from "date-fns/format";
import { FilterAlt as br } from "@styled-icons/material-outlined/FilterAlt";
import { FilterAlt as yr } from "@styled-icons/material/FilterAlt";
import { Search as xr } from "@styled-icons/material-outlined/Search";
import { MoreHoriz as vr } from "@styled-icons/material-outlined/MoreHoriz";
import { RemoveScrollBar as wr } from "react-remove-scroll-bar";
import { CSSTransition as _r } from "react-transition-group";
import { ArrowUpward as Cr } from "@styled-icons/material/ArrowUpward";
const kr = {
  brandWhite: {
    regular: "#ffffff",
    light: "#F5F5F5",
    medium: "#D8D8D8",
    bold: "#B1B1B1"
  },
  brandBlack: {
    regular: "#182026",
    light: "#44494D",
    medium: "#14191C",
    bold: "#000000"
  },
  brandGreen: {
    regular: "#01A77B",
    light: "#D1F2E7",
    medium: "#01A77B",
    bold: "#0D624C"
  },
  brandBlue: {
    regular: "#243568",
    light: "#667296",
    medium: "#404B6F",
    bold: "#192448"
  },
  sky: {
    regular: "#0F6BFF",
    light: "#87B5FF",
    medium: "#4775BF",
    bold: "#07357F"
  },
  nightSky: {
    regular: "#2B62BA",
    light: "#648CCC",
    medium: "#245199",
    bold: "#183666"
  },
  blueGum: {
    regular: "#239DCE",
    light: "#73C0DF",
    medium: "#208FBC",
    bold: "#176484"
  },
  eter: {
    regular: "#D0F6DD",
    light: "#DCF8E6",
    medium: "#BEE0C9",
    bold: "#ABCAB5"
  },
  liquen: {
    regular: "#43B7B7",
    light: "#76CACA",
    medium: "#3DA7A7",
    bold: "#318686"
  },
  coral: {
    regular: "#FF6F61",
    light: "#FF968C",
    medium: "#E86559",
    bold: "#BA5147"
  },
  sol: {
    regular: "#FFAC30",
    light: "#F9B96F",
    medium: "#D29249",
    bold: "#AB6B22"
  },
  alerta: {
    regular: "#E71321",
    light: "#F38990",
    medium: "#B34950",
    bold: "#730910"
  }
}, N = "font-family: Inter var, Inter, sans-serif", Ir = {
  superHeader: `
    ${N};
    font-size: 42px;
    line-height: 51px;
    font-weight: bold;
    letter-spacing: -0.04em;
  `,
  H1: `
    ${N};
    font-size: 32px;
    letter-spacing: -0.04em;
    line-height: 40px;
  `,
  H2: `
    ${N};
    font-size: 20px;
    letter-spacing: -0.012em;
    line-height: 30px;
  `,
  H3: `
    ${N};
    font-size: 16px;
    letter-spacing: -0.011em;
    line-height: 19px;
  `,
  body: `
    ${N};
    font-size: 16px;
    letter-spacing: -0.011em;
    line-height: 1.5;
  `,
  cell: `
    ${N};
    font-size: 13px;
    letter-spacing: -0.003em;
    line-height: 16px;
    font-feature-settings: 'tnum' 1;
  `,
  label: `
    ${N};
    font-size: 12px;
    letter-spacing: 0.06em;
    line-height: 15px;
    text-transform: uppercase;
  `,
  inputLabel: `
    ${N};
    font-size: 10px;
    letter-spacing: 0.09em;
    line-height: 12px;
    text-transform: uppercase;
  `,
  caption: `
    ${N};
    font-size: 10px;
    line-height: 14px;
  `
}, Nr = {
  sm: "320px",
  md: "640px",
  lg: "1280px",
  xl: "1440px",
  xxl: "1600px"
}, be = {
  rest: `0px 1px 3px rgba(24, 32, 38, 0.09), 0px 2px 2px rgba(24, 32, 38, 0.06),
    0px 3px 2px rgba(24, 32, 38, 0.07)`,
  elevate: "0px 8px 10px rgba(24, 32, 38, 0.09), 0px 6px 30px rgba(24, 32, 38, 0.11), 0px 16px 24px rgba(24, 32, 38, 0.13)",
  elevateCast: "0px 3px 9px rgba(24, 32, 38, 0.18)",
  pressed: "0px 1px 3px rgba(24, 32, 38, 0.18), 0px 2px 2px rgba(24, 32, 38, 0.11), 0px 0px 2px rgba(24, 32, 38, 0.13)"
}, ye = {
  card: {
    light: "#DAEFF7",
    light70: "#a4dff4",
    light50: "#80d3f2",
    light30: "#5cc9f0",
    regular: "#26b8ed",
    dark30: "#1b8dc2",
    dark50: "#1370a5",
    dark70: "#0b5388",
    dark: "#00275c",
    accent: "#00edff"
  },
  pay: {
    light: "#e6f8f8",
    light70: "#a1e4e3",
    light50: "#73d7d5",
    light30: "#45c9c8",
    regular: "#00b5b3",
    dark30: "#009499",
    dark50: "#007f87",
    dark70: "#006975",
    dark: "#00485b",
    accent: "#00f2de"
  },
  match: {
    light: "#e7d9fc",
    light70: "#c9bdfd",
    light50: "#b4aabfd",
    light30: "#a098fe",
    regular: "#827cff",
    dark30: "#7163ce",
    dark50: "#6552ad",
    dark70: "#5a418d",
    dark: "#49285c",
    accent: "#c8a1ff"
  },
  count: {
    light: "#ffe4d1",
    light70: "#fbd1a8",
    light50: "#f9c48c",
    light30: "#f6b770",
    regular: "#f2a447",
    dark30: "#e28940",
    dark50: "#d7783c",
    dark70: "#cc6638",
    dark: "#bc4b31",
    accent: "#ffda7c"
  }
}, xe = {
  light: "#d1f2e7",
  light70: "#93dbc7",
  light50: "#69ccb1",
  light30: "#3fbd9b",
  regular: "#01a77b",
  dark30: "#05926d",
  dark50: "#078464",
  dark70: "#09775a",
  dark: "#0d624c",
  accent: "#69f5a5"
}, ve = {
  increase: xe,
  gray: {
    white: "#ffffff",
    graySLight: "#fbfbfb",
    grayLight: "#f5f5f5",
    grayMedium: "#d8d8d8",
    grayBold: "#b1b1b1",
    blackSLight: "#6c7174",
    blackLight: "#42484d",
    blackMedium: "#2d3439",
    black: "#182026",
    subtleBorder: "rgba(24, 32, 38, 0.16)"
  },
  coral: {
    sLight: "#ffd1cc",
    light: "#ff968c",
    regular: "#ff6f61",
    medium: "#e05a4d",
    dark: "#c83f32"
  },
  primaryAction: {
    regular: "#0f6bff",
    dark: "#07357f",
    alpha: "rgba(15, 107, 255, 0.07)"
  },
  coralAlert: {
    regular: "#ff402e",
    dark: "#b80f00",
    alpha: "rgba(255, 64, 46, 0.07)"
  },
  ...ye
}, Mr = (e) => ({
  product: e ? ye[e] : xe,
  ...ve
}), Sr = (e) => ({
  productName: e || "increase",
  colors: kr,
  colorsNew: Mr(e),
  typography: Ir,
  breakpoints: Nr,
  shadows: be
});
function Y(e, t = "") {
  return Object.keys(e).reduce((o, n) => {
    const a = t ? `${t}-${n}` : n, l = e[n];
    if (typeof l == "object" && l !== null) {
      const c = /* @__PURE__ */ Y(l, a);
      return [...o, ...c];
    }
    return [...o, [a, l]];
  }, []);
}
const Br = /* @__PURE__ */ Y(ve, "--color").map((e) => e.join(": ")).join(`;
\r`), Ar = /* @__PURE__ */ Y(be, "--shadow").map((e) => e.join(": ")).join(`;
\r`), zr = /* @__PURE__ */ Qe([":root{", " ", "}html{color:var(--color-gray-black);}"], Br, Ar), ui = ({
  children: e,
  theme: t,
  productName: o
}) => {
  const n = Ke(() => Object.assign({}, Sr(o), t), [o, t]);
  return /* @__PURE__ */ s(Ze, { theme: n, children: [
    /* @__PURE__ */ r(zr, {}),
    e
  ] });
};
function mi(e, t) {
  return ({
    theme: o
  }) => o.colors[e][t];
}
function m(e) {
  return ({
    theme: t
  }) => t.typography[e];
}
const Lr = /* @__PURE__ */ i.button.withConfig({
  displayName: "Tab",
  componentId: "sc-t1660w-0"
})(["box-sizing:border-box;background:var(--color-gray-black);color:", " border:none;display:flex;align-items:center;", ";font-weight:500;height:100%;text-transform:uppercase;", " &:not(:disabled){", "}&:hover:not(:disabled){color:var(--color-gray-white);}&:disabled{color:var(--color-gray-blackSLight);}* + &{margin-left:40px;}"], ({
  active: e
}) => e ? "var(--color-gray-white);" : "var(--color-gray-grayBold);", m("label"), ({
  active: e
}) => e ? `
          border-bottom: 6px solid var(--color-gray-white);
          border-top: 6px solid transparent;
        ` : "", ({
  active: e
}) => !e && "cursor: pointer;"), Tr = /* @__PURE__ */ i.div.withConfig({
  displayName: "TabGroup",
  componentId: "sc-iaq8lp-0"
})(["display:flex;flex-direction:row;align-items:center;justify-content:center;width:100%;height:100%;a{text-decoration:none;}"]), Fr = /* @__PURE__ */ i.div.withConfig({
  displayName: "TabGroup__TabGroupWrapper",
  componentId: "sc-iaq8lp-1"
})(["display:flex;flex-direction:row;align-items:center;justify-content:space-between;background:var(--color-gray-black);width:100%;height:56px;"]), fi = /* @__PURE__ */ i.h1.withConfig({
  displayName: "typography__H1",
  componentId: "sc-1fu9yuq-0"
})(["", ";margin:0;font-weight:", ";"], m("H1"), ({
  weight: e
}) => e || "bold"), we = /* @__PURE__ */ i.h2.withConfig({
  displayName: "typography__H2",
  componentId: "sc-1fu9yuq-1"
})(["", ";margin:0;font-weight:", ";"], m("H2"), ({
  weight: e
}) => e || "bold"), T = /* @__PURE__ */ i.h3.withConfig({
  displayName: "typography__H3",
  componentId: "sc-1fu9yuq-2"
})(["", ";margin:0;font-weight:", ";"], m("H3"), ({
  weight: e
}) => e || "bold"), bi = /* @__PURE__ */ i.h1.withConfig({
  displayName: "typography__SuperHeader",
  componentId: "sc-1fu9yuq-3"
})(["", ";margin:0;font-weight:", ";"], m("superHeader"), ({
  weight: e
}) => e || "bold"), B = /* @__PURE__ */ i.p.withConfig({
  displayName: "typography__Paragraph",
  componentId: "sc-1fu9yuq-4"
})(["", ";margin:0;font-weight:", ";", " & strong{font-weight:bold;}"], m("body"), ({
  weight: e
}) => e || "normal", ({
  ellipsis: e
}) => e && `
      white-space: nowrap;
      text-overflow: ellipsis;
    `), K = /* @__PURE__ */ i.span.withConfig({
  displayName: "typography__CellText",
  componentId: "sc-1fu9yuq-5"
})(["", ";display:", ";font-weight:", ";font-feature-settings:'tnum' on;& strong{font-weight:bold;}"], m("cell"), ({
  inline: e
}) => e ? "inline" : "block", ({
  weight: e
}) => e || "normal"), yi = /* @__PURE__ */ i.span.withConfig({
  displayName: "typography__InlineText",
  componentId: "sc-1fu9yuq-6"
})(["", ";display:", ";font-weight:", ";& strong{font-weight:bold;}"], m("body"), ({
  inline: e
}) => e ? "inline" : "block", ({
  weight: e
}) => e || "normal"), $r = /* @__PURE__ */ i.label.withConfig({
  displayName: "typography__Label",
  componentId: "sc-1fu9yuq-7"
})(["", ";margin:0;font-weight:", ";& strong{font-weight:bold;}"], m("label"), ({
  weight: e
}) => e || "500"), X = /* @__PURE__ */ i.label.withConfig({
  displayName: "typography__InputLabel",
  componentId: "sc-1fu9yuq-8"
})(["", ";margin:0;font-weight:", ";& strong{font-weight:bold;}"], m("inputLabel"), ({
  weight: e
}) => e || "500"), xi = /* @__PURE__ */ i.label.withConfig({
  displayName: "typography__Caption",
  componentId: "sc-1fu9yuq-9"
})(["", ";margin:0;font-weight:", ";& strong{font-weight:bold;}"], m("caption"), ({
  weight: e
}) => e || "normal");
function Wr({
  className: e,
  href: t,
  displayName: o,
  description: n,
  ...a
}) {
  return /* @__PURE__ */ s("a", { className: e, href: t, ...a, children: [
    /* @__PURE__ */ r(we, { children: o }),
    n
  ] });
}
const Er = /* @__PURE__ */ i(Wr).withConfig({
  displayName: "ButtonDrawer__StyledButtonDrawer",
  componentId: "sc-16afblm-0"
})(["", " display:flex;flex-direction:column;justify-content:space-between;padding:10px;border-bottom:6px solid var(--color-", "-light);transition:0.25s;height:100%;a{color:inherit;}.drawer-image{margin-top:2.5rem;}p{margin:15px 0 0;font-size:13px;color:#38f;text-decoration:underline;}&:hover{border-bottom-color:var(--color-", "-regular);color:var(--color-primaryAction-dark);}&:hover h2{color:var(--color-primaryAction-dark);}img{height:34px;width:auto;}", ""], m("cell"), ({
  $colorPalette: e = "increase"
}) => e, ({
  $colorPalette: e = "increase"
}) => e, ({
  selected: e
}) => e && `
      border-bottom-color: var(--color-${({
  $colorPalette: t = "increase"
}) => t}-regular);
      pointer-events: none;
      background: var(--color-gray-white);
      box-shadow: var(--shadow-elevateCast);
    `), _e = /* @__PURE__ */ i.a.withConfig({
  displayName: "Link__BasicLink",
  componentId: "sc-163trrk-0"
})(["border:none;background:transparent;font:inherit;", " color:", ";display:inline-flex;align-items:center;text-decoration:underline;border-radius:4px;transition:all 200ms;:focus{box-shadow:0 0 0 4px var(--color-increase-light);outline:0;&::-moz-focus-inner{border:0;}}:disabled{opacity:0.4;}&:not(:disabled){cursor:pointer;&:hover{text-decoration:none;}&:hover:active{text-decoration:underline;}&:hover,&:active{color:", ";}}"], ({
  small: e
}) => e && "font-size: 0.815rem;", ({
  variant: e
}) => e === "alert" ? "var(--color-coralAlert-regular)" : "var(--color-primaryAction-regular)", ({
  variant: e
}) => e === "alert" ? "var(--color-coralAlert-dark)" : "var(--color-primaryAction-dark)"), L = (e) => /* @__PURE__ */ s(_e, { ...e, children: [
  e.children,
  e.target === "_blank" && // 18px / 13px => 1.385em
  /* @__PURE__ */ r(er, { size: "1.385em", style: {
    marginLeft: "1px"
  } })
] }), Dr = /* @__PURE__ */ i.div.withConfig({
  displayName: "SideBarLinks__SidebarStyled",
  componentId: "sc-1uqf74d-0"
})(["border-bottom:1px solid var(--color-gray-grayMedium);padding-bottom:15px;margin-bottom:15px;display:flex;flex-direction:column;justify-content:space-evenly;.sidebar-link{", ";display:block;padding:1.25rem;text-decoration:none;text-align:center;white-space:nowrap;color:var(--color-gray-black);}.sidebar-link:hover{color:var(--color-primaryAction-regular);text-decoration:underline;}@media (min-width:", "){position:relative;border-bottom:none;padding:0 1.25rem 0 0;margin-bottom:0;padding-left:32px;width:160px;.sidebar-link{padding:0;margin-bottom:6px;text-align:left;&:last-child{margin-bottom:0;}}&::before{position:absolute;content:'';background-color:var(--color-gray-grayMedium);width:1px;top:15px;left:0;bottom:15px;}}"], m("cell"), ({
  theme: e
}) => e.breakpoints.md), jr = ({
  sidebar: e,
  ...t
}) => /* @__PURE__ */ r(Dr, { ...t, children: /* @__PURE__ */ r("div", { children: e.map((o, n) => /* @__PURE__ */ r(L, { className: "sidebar-link", href: o.url, target: o.blank ? "blank" : void 0, children: o.label }, n)) }) }), Hr = 2, Or = 12, qr = ["start", "center", "end"], te = (e, t) => {
  let o = `
    grid-template-columns: repeat(${e}, 1fr);

    > * {
      grid-column: span ${e} / span ${e};
    }`;
  for (let n = 1; n <= e; n += 1)
    o += `> .grid-span-${t}-${n},
        .span-${t}-${n} {
          grid-column-start: span ${n};
          grid-column-end: span ${n};
      }`;
  for (let n = 1; n <= e; n += 1)
    o += `
      > .grid-start-${t}-${n} {
        grid-column-start: ${n};
      }`;
  for (const n of qr)
    o += `
      > .grid-align-${n} {
        align-self: ${n !== "center" ? "flex-" : ""}${n};
      }
      > .grid-justify-${n} {
        justify-self: ${n !== "center" ? "flex-" : ""}${n};
      }`;
  return o;
}, D = /* @__PURE__ */ i.div.withConfig({
  displayName: "Grid",
  componentId: "sc-wnbo0o-0"
})(["display:grid;", " ", " ", " ", " ", " ", " ", " @media (min-width:", "){", "}"], ({
  columnGap: e = 1
}) => `grid-column-gap: ${e * 16}px;`, ({
  rowGap: e
}) => e ? `grid-row-gap: ${e * 8}px;` : null, ({
  alignItems: e
}) => e && `align-items: ${e};`, ({
  justifyItems: e
}) => e && `justify-items: ${e};`, ({
  alignContent: e
}) => e && `align-content: ${e};`, ({
  justifyContent: e
}) => e && `justify-content: ${e};`, /* @__PURE__ */ te(Hr, "mobile"), ({
  theme: e
}) => e.breakpoints.md, /* @__PURE__ */ te(Or, "desktop")), Rr = /* @__PURE__ */ i(D).withConfig({
  displayName: "MainNavMenu__NavMenu",
  componentId: "sc-15se6r1-0"
})(["background:var(--color-gray-white);position:absolute;top:0;width:100%;min-height:100px;transition:0.25s;transform:translateY(", ");z-index:1;box-shadow:", ";overflow-y:auto;display:flex;transform:translateY(", ");height:auto;.container{height:140px;padding:0 26px;}a{color:inherit;}"], ({
  visible: e
}) => e ? "46px" : "-100%", ({
  visible: e
}) => e ? "rgba(0, 0, 0, 0.05) 0px 2px 4px" : "none", ({
  visible: e
}) => e ? "56px" : "-100%"), Ce = /* @__PURE__ */ i.div.withConfig({
  displayName: "MainNavMenu__IconWrapper",
  componentId: "sc-15se6r1-1"
})(["svg{width:1.25rem;height:1.25rem;}"]), Pr = /* @__PURE__ */ i.div.withConfig({
  displayName: "MainNavMenu__SecondLevelActions",
  componentId: "sc-15se6r1-2"
})(["position:relative;padding:16px 0;display:flex;flex-direction:column;justify-content:center;.sl-container{display:inline-flex;align-items:center;width:210px;padding:10px;border-radius:9px;cursor:pointer;text-decoration:none;&:hover{color:var(--color-primaryAction-regular);", "{color:var(--color-primaryAction-regular);}}.sl-title{", ";line-height:1.25rem;margin:0.25rem 0;text-align:center;}.sl-text{margin:0;", ";text-align:center;}", "{margin-right:10px;}}"], B, m("body"), m("cell"), Ce);
function Gr({
  country: e,
  onProductAcquire: t,
  products: o,
  secondLevel: n,
  sidebar: a,
  visible: l
}) {
  const c = (d) => (h) => {
    h.preventDefault(), t(d);
  };
  return /* @__PURE__ */ r(Rr, { visible: l, children: /* @__PURE__ */ s(D, { className: "container", columnGap: 2, children: [
    o.all.filter(({
      countries: d
    }) => d.includes(e)).map((d) => {
      const h = o.active[e], p = d.is_free || h && h.includes(d.name);
      return /* @__PURE__ */ r(Er, { $colorPalette: d.display_name.toLowerCase(), className: "span-desktop-2", description: d.description, displayName: d.display_name, href: p ? d.uri : "#", onClick: p ? void 0 : c(d), selected: o.current === d.name }, d.name);
    }),
    /* @__PURE__ */ r(jr, { className: "span-desktop-2", sidebar: a }),
    /* @__PURE__ */ r(Pr, { className: "span-desktop-2", children: n.map((d, h) => /* @__PURE__ */ s("a", { className: "sl-container", href: d.url, target: "blank", children: [
      /* @__PURE__ */ r(Ce, { children: d.logo }),
      /* @__PURE__ */ s("div", { children: [
        /* @__PURE__ */ r(B, { style: {
          fontWeight: "bold"
        }, children: d.name }),
        /* @__PURE__ */ r("p", { className: "sl-text", children: d.text })
      ] })
    ] }, h)) })
  ] }) });
}
const Vr = /* @__PURE__ */ i.div.withConfig({
  displayName: "MenuProfile__PopupMenu",
  componentId: "sc-17mo00-0"
})(["padding:15px;z-index:4;color:var(--color-gray-black);font-size:13px;line-height:24px;.user{font-size:16px;line-height:19px;font-weight:600;padding:0 8px;margin-bottom:3px;}a{text-decoration:none;color:var(--color-gray-black);border-radius:4px;padding:8px;display:block;", ";}a:hover{text-decoration:none;background:var(--color-gray-grayLight);}hr{background:transparent;margin:0;margin-bottom:8px;padding:8px 0 0;border:none;border-bottom:1px solid var(--color-gray-grayMedium);}"], m("cell"));
function Ur({
  urls: e,
  profileLinks: t,
  userName: o
}) {
  return /* @__PURE__ */ r(rr, { closeOnDocumentClick: !0, contentStyle: {
    zIndex: 4,
    padding: 0,
    boxShadow: "var(--shadow-elevateCast)",
    border: "none",
    minWidth: "220px"
  }, position: "bottom right", trigger: () => /* @__PURE__ */ s(Me, { children: [
    /* @__PURE__ */ r(tr, { size: "24" }),
    /* @__PURE__ */ r("span", { children: "Mi Cuenta" })
  ] }), children: /* @__PURE__ */ s(Vr, { children: [
    /* @__PURE__ */ r("div", { className: "user", children: o }),
    /* @__PURE__ */ r(L, { href: `${e.platform}/settings`, children: "Ajustes de cuenta" }),
    t.length > 0 && /* @__PURE__ */ s(C, { children: [
      /* @__PURE__ */ r("hr", {}),
      t.map((n) => /* @__PURE__ */ r(L, { href: n.url, target: n.blank ? "_blank" : "_self", children: n.label }, n.url))
    ] }),
    /* @__PURE__ */ r("hr", {}),
    /* @__PURE__ */ r(L, { href: `${e.auth}/logout`, children: "Cerrar Sesión" })
  ] }) });
}
function ke(e, t) {
  function o(n) {
    if (e instanceof Array) {
      e.every((a) => a.current && !a.current.contains(n.target)) && t(n);
      return;
    }
    e.current && !e.current.contains(n.target) && t(n);
  }
  le(() => {
    if (!(typeof document > "u"))
      return document.addEventListener("mousedown", o), () => {
        document.removeEventListener("mousedown", o);
      };
  });
}
function Ie({
  children: e,
  selector: t
}) {
  const [o, n] = _(null);
  return le(() => {
    if (typeof document > "u") return;
    const a = document.querySelector(t);
    n(a);
  }, []), o === null ? null : cr.createPortal(e, o);
}
const Ne = /* @__PURE__ */ de(!1);
function Yr({
  children: e
}) {
  return /* @__PURE__ */ r(Ne.Provider, { value: !0, children: e });
}
function Kr() {
  return ce(Ne);
}
const Xr = /* @__PURE__ */ i.div.withConfig({
  displayName: "FloatingMenu__Wrapper",
  componentId: "sc-35pqwx-0"
})(["display:inline-block;"]), Jr = /* @__PURE__ */ i.div.withConfig({
  displayName: "FloatingMenu__MenuWrapper",
  componentId: "sc-35pqwx-1"
})(["position:absolute;z-index:3;", " ", ""], ({
  top: e
}) => e ? `top: ${e};` : null, ({
  left: e
}) => e ? `left: ${e};` : null);
function A({
  children: e,
  renderTrigger: t,
  onClickOutside: o,
  closeOnClickOutside: n = !0,
  onmountOnHide: a = !0,
  ...l
}) {
  const c = Kr(), [d, h] = _(!1), [p, g] = _({}), u = E(null), f = E(null);
  ke([f, u], () => {
    o && o(), d && n && h((x) => !x);
  }), Xe(() => {
    if (u.current === null || c) return;
    const x = u.current, $ = () => {
      const O = x.getBoundingClientRect();
      g({
        top: `${O.top + O.height + window.scrollY}px`,
        left: `${O.left}px`
      });
    };
    return $(), window.addEventListener("resize", $), () => {
      window.removeEventListener("resize", $);
    };
  }, [d, c]);
  const I = {
    toggleShowMenu: () => h((x) => !x),
    setShowMenu: (x) => h(x),
    showMenu: d,
    wrapperRef: u
  }, y = () => {
    if (!d) return null;
    const x = /* @__PURE__ */ s(Jr, { ref: f, ...p, children: [
      a && d && e(I),
      !a && /* @__PURE__ */ r("div", { style: {
        opacity: d ? 1 : 0,
        visibility: d ? "visible" : "hidden"
      }, children: e(I) })
    ] });
    return c ? x : /* @__PURE__ */ r(Yr, { children: /* @__PURE__ */ r(Ie, { selector: "body", children: x }) });
  };
  return /* @__PURE__ */ s(Xr, { ref: u, ...l, children: [
    t({
      "aria-expanded": d,
      "aria-haspopup": !0
    }, I),
    y()
  ] });
}
const Qr = /* @__PURE__ */ i(B).withConfig({
  displayName: "NotificationsButton__CreatedAt",
  componentId: "sc-1mitdpm-0"
})(["color:var(--color-gray-grayBold);"]), Zr = /* @__PURE__ */ i.div.withConfig({
  displayName: "NotificationsButton__Menu",
  componentId: "sc-1mitdpm-1"
})(["position:absolute;background:var(--color-gray-white);right:-40px;top:4px;box-shadow:var(--shadow-elevateCast);max-height:320px;overflow-y:auto;overflow-x:hidden;"]), et = /* @__PURE__ */ i.div.withConfig({
  displayName: "NotificationsButton__NotificationElement",
  componentId: "sc-1mitdpm-2"
})(["width:360px;padding:18px;:not(:last-child){border-bottom:1px solid var(--color-gray-grayMedium);}"]), rt = /* @__PURE__ */ i.div.withConfig({
  displayName: "NotificationsButton__Separator",
  componentId: "sc-1mitdpm-3"
})(["border-bottom:1px solid var(--color-gray-grayMedium);"]);
function tt({
  notifications: e,
  onNotificationsOpen: t
}) {
  const o = e.length > 0, n = e.some(({
    read: l
  }) => !l), a = o ? "Ver notificaciones" : "No hay notificaciones";
  return /* @__PURE__ */ r(A, { renderTrigger: (l, {
    toggleShowMenu: c,
    showMenu: d
  }) => /* @__PURE__ */ r(Me, { ...l, "aria-label": a, disabled: !o, onClick: () => {
    t && !d && t(), c();
  }, title: a, children: n ? /* @__PURE__ */ r(lr, { size: "24", style: {
    color: "var(--color-coral-medium)"
  } }) : /* @__PURE__ */ r(ar, { size: "24" }) }), children: () => /* @__PURE__ */ s(Zr, { children: [
    /* @__PURE__ */ r(T, { style: {
      padding: "18px"
    }, children: "Notificaciones" }),
    /* @__PURE__ */ r(rt, {}),
    e.sort((l, c) => c.createdAt.valueOf() - l.createdAt.valueOf()).map(({
      id: l,
      createdAt: c,
      title: d,
      body: h
    }) => /* @__PURE__ */ s(et, { children: [
      /* @__PURE__ */ s(Qr, { title: w(c, "dd/MM/yyyy HH:mm"), children: [
        "Hace ",
        ir(c, /* @__PURE__ */ new Date(), {
          locale: P
        })
      ] }),
      d && /* @__PURE__ */ r(B, { children: /* @__PURE__ */ r("strong", { children: d }) }),
      /* @__PURE__ */ r(B, { children: h })
    ] }, l))
  ] }) });
}
const Me = /* @__PURE__ */ i.button.withConfig({
  displayName: "ApplicationHeader__HeaderButton",
  componentId: "sc-mbd47h-0"
})(["color:var(--color-gray-black);margin:0px;padding:0px;border:none;background:transparent;font-size:13px;padding:6px;border-radius:4px;display:inline-flex;align-items:center;justify-content:center;min-width:40px;height:40px;> svg:not(:only-child){margin-right:6px;}:not(:disabled){cursor:pointer;&:focus,&:active,&:hover{outline:none;background:var(--color-gray-grayLight);}}"]), ot = /* @__PURE__ */ i.div.withConfig({
  displayName: "ApplicationHeader__ApplicationHeaderContainer",
  componentId: "sc-mbd47h-1"
})(["position:relative;a{color:inherit;text-decoration:none;}"]), nt = /* @__PURE__ */ i.div.withConfig({
  displayName: "ApplicationHeader__ApplicationHeaderWrapper",
  componentId: "sc-mbd47h-2"
})(["background:var(--color-gray-white);position:relative;z-index:2;border-bottom:1px solid var(--color-gray-grayMedium);display:flex;align-items:center;justify-content:space-between;height:56px;padding:0 26px;"]), it = /* @__PURE__ */ i.nav.withConfig({
  displayName: "ApplicationHeader__ApplicationHeaderContent",
  componentId: "sc-mbd47h-3"
})(["display:flex;margin:auto;justify-content:space-between;align-items:center;width:100%;"]), at = /* @__PURE__ */ i.div.withConfig({
  displayName: "ApplicationHeader__LogoWrapper",
  componentId: "sc-mbd47h-4"
})(["display:flex;align-items:center;margin:0;padding:0;background:transparent;border:none;cursor:pointer;user-select:none;color:var(--color-gray-black);:focus{outline:none;}.logo{height:25px;width:25px;}.brandName{", ";font-weight:bold;margin-left:8px;}.drawerToggle{display:flex;align-items:center;color:", ";}.drawerToggle path{fill:", ";}.drawerToggle:hover{color:var(--color-primaryAction-regular);}.drawerToggle:hover path{fill:var(--color-primaryAction-regular);}"], m("H3"), ({
  isOpen: e
}) => e ? "var(--color-primaryAction-regular)" : null, ({
  isOpen: e
}) => e ? "var(--color-primaryAction-regular)" : null), lt = /* @__PURE__ */ i.div.withConfig({
  displayName: "ApplicationHeader__RightContent",
  componentId: "sc-mbd47h-5"
})(["display:flex;align-items:center;.alerts{margin-right:15px;padding-right:15px;border-right:1px solid var(--color-gray-grayMedium);color:var(--color-gray-grayMedium);}"]), ct = /* @__PURE__ */ i.div.withConfig({
  displayName: "ApplicationHeader__Separator",
  componentId: "sc-mbd47h-6"
})(["height:20px;border-right:1px solid var(--color-gray-grayBold);margin:0 8px;"]);
function dt({
  products: e,
  links: t,
  urls: o,
  country: n,
  onProductAcquire: a,
  notifications: l,
  onNotificationsOpen: c,
  userName: d,
  ...h
}) {
  const [p, g] = _(!1), u = E(null);
  ke(u, () => {
    p && g(!p);
  });
  const f = e.all.find(({
    name: y
  }) => y === e.current), b = f ? f.display_name : "Increase", v = () => g((y) => !y), I = t.sidebar.concat([{
    label: "Más Productos",
    url: `${o.platform}/`,
    blank: !1
  }, {
    label: "Ajustes",
    url: `${o.platform}/settings/`,
    blank: !1
  }]);
  return /* @__PURE__ */ s(ot, { ref: u, ...h, children: [
    /* @__PURE__ */ r(Gr, { country: n, onProductAcquire: a, products: e, secondLevel: t.secondLevel, sidebar: I, visible: p }),
    /* @__PURE__ */ r(nt, { children: /* @__PURE__ */ s(it, { children: [
      /* @__PURE__ */ r("div", { className: "logo", children: /* @__PURE__ */ s(at, { isOpen: p, onClick: v, children: [
        b.toLocaleLowerCase() === "increase" ? /* @__PURE__ */ r(pe, { height: "42", width: "138" }) : /* @__PURE__ */ r(he, { height: "34", width: "34" }),
        /* @__PURE__ */ s("div", { className: "drawerToggle", children: [
          b.toLocaleLowerCase() !== "increase" ? /* @__PURE__ */ r("span", { className: "brandName", children: b }) : null,
          p ? /* @__PURE__ */ r(nr, { size: "24" }) : /* @__PURE__ */ r(j, { size: "24" })
        ] })
      ] }) }),
      /* @__PURE__ */ s(lt, { children: [
        l && /* @__PURE__ */ s(C, { children: [
          /* @__PURE__ */ r(tt, { notifications: l, onNotificationsOpen: c }),
          /* @__PURE__ */ r(ct, {})
        ] }),
        /* @__PURE__ */ r("div", { className: "account", children: /* @__PURE__ */ r(Ur, { profileLinks: t.profile, urls: o, userName: d }) })
      ] })
    ] }) })
  ] });
}
const st = /* @__PURE__ */ i(L).withConfig({
  displayName: "MenuLink",
  componentId: "sc-quczk-0"
})(["", ";color:var(--color-gray-black);"], m("cell")), pt = /* @__PURE__ */ i.div.withConfig({
  displayName: "VerticalNavigation",
  componentId: "sc-2b0ong-0"
})(["display:inline-flex;flex-direction:column;align-items:flex-start;margin:16px 0;height:calc(100% - 32px);gap:16px;", ""], ({
  responsive: e,
  theme: t,
  justifyContent: o
}) => e && `
    @media (max-width: ${t.breakpoints.md}) {
      margin: 0;
      justify-content: ${o};
      flex-direction: row;
      flex-wrap: wrap;
    }
  `), oe = /* @__PURE__ */ i(L).withConfig({
  displayName: "VerticalNavigation__VerticalNavigationElement",
  componentId: "sc-2b0ong-1"
})(["", " color:var(--color-gray-black);height:26px;cursor:pointer;border:0;border-radius:0;background:transparent;padding-left:11px;border-left:3px solid transparent;&,:hover{text-decoration:none;}", " ", " ", ";"], m("cell"), ({
  disabled: e
}) => e ? `
          cursor: default;
          opacity: 0.36;
        ` : `
          :hover {
            color: var(--color-primaryAction-regular);
          }
        `, ({
  active: e
}) => e && `
      color: var(--color-primaryAction-regular);
      border-left: 3px solid var(--color-primaryAction-regular);
      cursor: default;
      font-weight: bold;
    `, ({
  responsive: e,
  theme: t,
  active: o
}) => e && `
      @media (max-width: ${t.breakpoints.md}) {
        height: auto;
        padding: 6px 4px;
        border-left: none;
        border-bottom: 3px solid
          ${o ? "var(--color-primaryAction-regular)" : "transparent"};
      }
    `);
function ht({
  tabs: e,
  onElementClicked: t
}) {
  return /* @__PURE__ */ r(pt, { children: e.map((o) => {
    const n = (a) => {
      o.onClick && o.onClick(a), t(a);
    };
    return o.as === "button" ? /* @__PURE__ */ r(oe, { as: "button", ...o, onClick: n, children: o.name }, o.name) : /* @__PURE__ */ r(oe, { active: o.active, ...o, onClick: n, children: o.name }, o.name);
  }) });
}
const gt = /* @__PURE__ */ i.div.withConfig({
  displayName: "ApplicationHeaderMobile__Backdrop",
  componentId: "sc-jwl2pj-0"
})(["", " position:absolute;top:0;left:0;height:100vh;width:100vw;background:rgba(24,32,38,0.7);z-index:1;"], ({
  isMenuOpen: e
}) => !e && "display: none;"), ut = /* @__PURE__ */ i.div.withConfig({
  displayName: "ApplicationHeaderMobile__ApplicationHeaderMobileWrapper",
  componentId: "sc-jwl2pj-2"
})(["margin:8px 8px 0 8px;padding:8px;height:56px;width:calc(100% - 16px);background:var(--color-gray-white);display:flex;position:fixed;z-index:1;top:0;align-items:center;justify-content:space-between;border-radius:9px;box-shadow:var(--shadow-rest);.left > svg{margin-right:8px;}.menu{background:transparent;height:24px;width:24px;border:none;background-color:var(--color-gray-white);padding:0;}.left{display:flex;align-items:center;}"]), mt = /* @__PURE__ */ i.div.withConfig({
  displayName: "ApplicationHeaderMobile__MobileDrawer",
  componentId: "sc-jwl2pj-3"
})(["width:calc(100vw - 58px);height:100vh;z-index:1;background:var(--color-gray-white);position:absolute;top:0;right:-100%;transition:right 250ms;overflow:hidden;", ""], ({
  isMenuOpen: e
}) => e && "right: 0;"), ft = /* @__PURE__ */ i.div.withConfig({
  displayName: "ApplicationHeaderMobile__UserMenu",
  componentId: "sc-jwl2pj-4"
})(["height:72px;padding:16px;background:var(--color-gray-grayLight);width:100%;"]);
function bt({
  products: e,
  isMenuOpen: t,
  userName: o,
  onMenuOpen: n,
  tabs: a,
  onProductAcquire: l,
  ...c
}) {
  const d = e.all.find(({
    name: p
  }) => p === e.current), h = d ? d.display_name : "Increase";
  return /* @__PURE__ */ s("nav", { ...c, children: [
    /* @__PURE__ */ s(ut, { children: [
      /* @__PURE__ */ r("div", { className: "left", children: h.toLocaleLowerCase() === "increase" ? /* @__PURE__ */ r(pe, { height: "42", width: "138" }) : /* @__PURE__ */ s(C, { children: [
        /* @__PURE__ */ r(he, { height: "34", width: "34" }),
        /* @__PURE__ */ r(T, { children: h })
      ] }) }),
      a !== null && /* @__PURE__ */ r("button", { "aria-label": "abrir menú", className: "menu", onClick: n, children: /* @__PURE__ */ r(dr, { size: "24" }) })
    ] }),
    /* @__PURE__ */ r(gt, { isMenuOpen: t, onClick: n }),
    a !== null && /* @__PURE__ */ s(mt, { isMenuOpen: t, children: [
      /* @__PURE__ */ s(ft, { children: [
        /* @__PURE__ */ r(T, { children: o }),
        /* @__PURE__ */ r(st, { href: "#", style: {
          color: "black"
        }, children: "Ajustes de cuenta" })
      ] }),
      /* @__PURE__ */ r(ht, { onElementClicked: n, tabs: a })
    ] })
  ] });
}
const yt = /* @__PURE__ */ i.div.withConfig({
  displayName: "OnTopNotification__OnTopNotificationContainer",
  componentId: "sc-2xwl1w-0"
})(["", ";height:38px;width:100%;padding:0 8px;display:grid;align-items:center;grid-template-columns:auto 1fr auto;grid-column-gap:8px;&,button,a,a:hover{color:var(--color-gray-white) !important;}button{border:0;background:transparent;display:inline-flex;justify-content:center;align-items:center;}background:", ";"], ({
  theme: e
}) => e.typography.body, ({
  variant: e
}) => {
  switch (e) {
    case "info":
    default:
      return "var(--color-primaryAction-regular)";
    case "alert":
      return "var(--color-count-regular)";
    case "error":
      return "var(--color-coral-medium)";
    case "success":
      return "var(--color-increase-regular)";
  }
});
function xt({
  variant: e
}) {
  switch (e) {
    case "info":
    default:
      return /* @__PURE__ */ r(hr, { size: "24" });
    case "alert":
      return /* @__PURE__ */ r(pr, { size: "24" });
    case "error":
      return /* @__PURE__ */ r(gr, { size: "24" });
    case "success":
      return /* @__PURE__ */ r(H, { size: "24" });
  }
}
function vt({
  children: e,
  onClose: t,
  variant: o,
  ...n
}) {
  return /* @__PURE__ */ s(yt, { variant: o, ...n, children: [
    /* @__PURE__ */ r(xt, { variant: o }),
    /* @__PURE__ */ r("div", { children: e }),
    /* @__PURE__ */ r("button", { onClick: t, children: /* @__PURE__ */ r(sr, { size: "24" }) })
  ] });
}
const wt = /* @__PURE__ */ i.div.withConfig({
  displayName: "ApplicationLayout__ApplicationLayoutWrapper",
  componentId: "sc-a3jzlx-0"
})(["position:relative;padding-top:72px;", " @media (max-width:", "){overflow-x:hidden;}@media (min-width:", "){padding-top:56px;}"], ({
  isMobileMenuOpen: e
}) => e ? `
          height: 100vh;
          overflow: hidden;
        ` : null, ({
  theme: e
}) => e.breakpoints.md, ({
  theme: e
}) => e.breakpoints.md), _t = /* @__PURE__ */ i(dt).withConfig({
  displayName: "ApplicationLayout__ApplicationHeaderOnlyDesktop",
  componentId: "sc-a3jzlx-1"
})(["position:absolute;top:0;width:100%;display:none;@media (min-width:", "){display:block;}"], ({
  theme: e
}) => e.breakpoints.md), Ct = /* @__PURE__ */ i(bt).withConfig({
  displayName: "ApplicationLayout__ApplicationHeaderOnlyMobile",
  componentId: "sc-a3jzlx-2"
})(["@media (min-width:", "){display:none;}"], ({
  theme: e
}) => e.breakpoints.md), kt = /* @__PURE__ */ i(Fr).withConfig({
  displayName: "ApplicationLayout__TabGroupOnlyDesktop",
  componentId: "sc-a3jzlx-3"
})(["display:none;position:sticky;top:0;width:100%;z-index:1;@media (min-width:", "){display:flex;}"], ({
  theme: e
}) => e.breakpoints.md), It = /* @__PURE__ */ i.div.withConfig({
  displayName: "ApplicationLayout__ContentWrapper",
  componentId: "sc-a3jzlx-4"
})(["min-width:100%;z-index:0;position:relative;"]);
function vi({
  children: e,
  tabs: t,
  leftContext: o,
  rightContext: n,
  onTopNotification: a,
  ...l
}) {
  const [c, d] = _(!1), h = () => d((p) => !p);
  return /* @__PURE__ */ s(C, { children: [
    a && /* @__PURE__ */ r(vt, { style: {
      position: "relative",
      zIndex: 2
    }, ...a }),
    /* @__PURE__ */ s(wt, { isMobileMenuOpen: c, children: [
      t !== null && /* @__PURE__ */ s(kt, { children: [
        o,
        /* @__PURE__ */ r(Tr, { children: t.map(({
          active: p,
          name: g,
          ...u
        }) => /* @__PURE__ */ r(Lr, { active: p, ...u, children: g }, g)) }),
        n
      ] }),
      /* @__PURE__ */ r(_t, { ...l }),
      /* @__PURE__ */ r(Ct, { isMenuOpen: c, onMenuOpen: h, tabs: t, ...l }),
      /* @__PURE__ */ r(It, { children: e })
    ] })
  ] });
}
const Nt = {
  primary: `
    background: var(--color-primaryAction-regular);
    border: 1px solid var(--color-gray-subtleBorder);
    color: var(--color-gray-white);

    :not(:disabled) {
      :not(:active):hover {
        box-shadow: 1px 3px 4px rgba(15, 107, 255, 0.27),
          1px 2px 2px rgba(15, 107, 255, 0.36);
      }

      :active {
        background: var(--color-primaryAction-dark);
      }
    }
  `,
  outline: `
    background: transparent;
    border: 1px solid var(--color-primaryAction-regular);
    color: var(--color-primaryAction-regular);

    :not(:disabled) {
      :hover {
        background: var(--color-primaryAction-alpha);
      }

      :active {
        background: var(--color-primaryAction-dark);
        border: 1px solid var(--color-primaryAction-dark);
        color: var(--color-gray-white);
      }
    }
 `,
  invisible: `
    background: transparent;
    border: none;
    color: var(--color-primaryAction-regular);

    :not(:disabled) {
      :hover {
        background: var(--color-primaryAction-alpha);
      }

      :active {
        background: var(--color-gray-white);
        color: var(--color-primaryAction-dark);
      }
    }
  `,
  alert: `
    background: var(--color-coralAlert-regular);
    border: 1px solid var(--color-gray-subtleBorder);
    color: var(--color-gray-white);

    :not(:disabled) {
      :not(:active):hover {
        box-shadow: 1px 3px 4px rgba(223, 19, 33, 0.27),
          1px 2px 2px rgba(223, 19, 33, 0.36);
      }

      :active {
        background: var(--color-coralAlert-dark);
      }
    }
  `,
  alertOutline: `
    background: transparent;
    border: 1px solid var(--color-coralAlert-regular);
    color: var(--color-coralAlert-regular);

    :not(:disabled) {
      :hover {
        background: var(--color-coralAlert-alpha);
      }

      :active {
        background: var(--color-coralAlert-dark);
        border: 1px solid var(--color-coralAlert-dark);
        color: var(--color-gray-white);
      }
    }
  `,
  alertInvisible: `
    background: transparent;
    border: none;
    color: var(--color-coralAlert-regular);

    :not(:disabled) {
      :hover {
        background: var(--color-coralAlert-alpha);
      }

      :active {
        background: var(--color-coralAlert-dark);
        border: 1px solid var(--color-coralAlert-dark);
        color: var(--color-gray-white);
      }
    }
  `
}, Mt = /* @__PURE__ */ i.svg.withConfig({
  displayName: "Spinner__SVGStyled",
  componentId: "sc-dnhppd-0"
})(["& .path{stroke-dasharray:187;stroke-dashoffset:0;transform-origin:center;stroke:var(--color-increase-light30);animation:dash 1.4s ease-in-out infinite;}width:", "px;height:", "px;animation:rotator 1.4s linear infinite;@keyframes dash{0%{stroke-dashoffset:187;}50%{stroke-dashoffset:", ";transform:rotate(135deg);}100%{stroke-dashoffset:187;transform:rotate(450deg);}}@keyframes rotator{0%{transform:rotate(0deg);}100%{transform:rotate(270deg);}}"], ({
  size: e
}) => e || 24, ({
  size: e
}) => e || 24, 187 / 4), St = (e) => /* @__PURE__ */ r(Mt, { className: "spinner", height: "65px", viewBox: "0 0 66 66", width: "65px", xmlns: "http://www.w3.org/2000/svg", ...e, children: /* @__PURE__ */ r("circle", { className: "path", cx: "33", cy: "33", fill: "none", r: "30", strokeLinecap: "round", strokeWidth: "6" }) }), Bt = /* @__PURE__ */ i.button.withConfig({
  displayName: "Button__BaseButton",
  componentId: "sc-1seb4sf-0"
})(["", ";display:inline-flex;gap:4px;align-items:center;justify-content:center;height:", ";border-radius:4px;padding:0 ", ";width:max-content;white-space:nowrap;text-decoration:none;cursor:pointer;font-weight:700;transition:all 100ms ease-in-out;", " :disabled{opacity:0.36;}:focus{box-shadow:0 0 0 4px var(--color-increase-light);outline:0;&::-moz-focus-inner{border:0;}}svg{fill:currentColor;height:18px;width:18px;}svg .path{stroke:currentcolor;}"], ({
  size: e
}) => m(e === "small" ? "cell" : "body"), ({
  size: e
}) => e === "small" ? "30px" : "40px", ({
  icon: e,
  size: t
}) => e || t === "small" ? "8px" : "20px", ({
  variant: e = "primary"
}) => Nt[e]), M = ({
  children: e,
  icon: t,
  variant: o,
  buttonType: n,
  isLoading: a,
  disabled: l,
  ...c
}) => /* @__PURE__ */ s(Bt, { icon: t, disabled: l || a, variant: o || n, ...c, children: [
  a ? /* @__PURE__ */ r(St, { size: 16 }) : t,
  " ",
  e
] }), J = /* @__PURE__ */ V(["0%{opacity:0;}100%{opacity:1;}"]), At = /* @__PURE__ */ i.div.attrs({
  children: /* @__PURE__ */ r(j, {})
}).withConfig({
  displayName: "ButtonMenu__ButtonMenuButtonArrow",
  componentId: "sc-10dlhdf-0"
})(["display:inline-flex;justify-content:center;align-items:center;width:32px;height:28px;margin-left:8px;border-left:1px solid var(--color-gray-subtleBorder);"]), zt = /* @__PURE__ */ i(M).withConfig({
  displayName: "ButtonMenu__ButtonMenuButton",
  componentId: "sc-10dlhdf-1"
})(["padding-right:0;:focus{background:var(--color-primaryAction-dark);}svg{width:24px;height:24px;}"]), wi = /* @__PURE__ */ i.button.withConfig({
  displayName: "ButtonMenu__ButtonMenuItem",
  componentId: "sc-10dlhdf-2"
})(["", " border:0;border-radius:4px;padding:10px;text-align:", ";background:var(--color-gray-white);:not(:disabled){cursor:pointer;}:not(:disabled):hover{background:var(--color-increase-light);}:disabled{opacity:0.5;}"], ({
  theme: e
}) => e.typography.cell, ({
  textAlign: e
}) => e || "left"), Lt = /* @__PURE__ */ i.div.attrs({
  role: "menu"
}).withConfig({
  displayName: "ButtonMenu__Menu",
  componentId: "sc-10dlhdf-3"
})(["background:var(--color-gray-white);box-shadow:var(--shadow-elevateCast);border:1px solid var(--color-gray-subtleBorder);border-radius:4px;position:absolute;top:4px;animation:", " 100ms ease-in;left:0;width:", "px;display:flex;flex-direction:column;padding:3px;"], J, ({
  width: e
}) => e || 240);
function _i({
  children: e,
  text: t,
  ...o
}) {
  return /* @__PURE__ */ r(A, { renderTrigger: (n, {
    toggleShowMenu: a
  }) => /* @__PURE__ */ s(zt, { ...n, onClick: a, ...o, children: [
    t,
    " ",
    /* @__PURE__ */ r(At, {})
  ] }), children: (n) => /* @__PURE__ */ r(Lt, { width: n.wrapperRef.current?.offsetWidth, children: e(n) }) });
}
const Se = /* @__PURE__ */ V(["0%{transform:scale(0);}95%{transform:scale(1.05);}98%{transform:scale(0.98);}100%{transform:scale(1);}"]), Tt = /* @__PURE__ */ i.div.withConfig({
  displayName: "CheckboxInput__CheckboxInputWrapper",
  componentId: "sc-u0beuk-0"
})(["display:inline-block;height:18px;width:18px;padding:0;", " border-radius:2px;position:relative;box-sizing:border-box;transition:box-shadow 200ms;flex-shrink:0;:focus-within{box-shadow:0 0 0 4px var(--color-increase-light);outline:0;}"], ({
  checked: e
}) => e ? "background: var(--color-increase-light30);" : "border: 2px solid var(--color-gray-grayMedium);"), Be = /* @__PURE__ */ i.input.attrs({
  type: "checkbox"
}).withConfig({
  displayName: "CheckboxInput__CheckboxInputControl",
  componentId: "sc-u0beuk-1"
})(["width:18px;height:18px;margin:0;box-sizing:border-box;opacity:0;position:absolute;top:-2px;left:-2px;border:0;&:not(:disabled){cursor:pointer;}&:focus{outline:none;}"]), Ft = /* @__PURE__ */ i(H).withConfig({
  displayName: "CheckboxInput__CheckboxInputFill",
  componentId: "sc-u0beuk-2"
})(["width:calc(100% - 2px);height:calc(100% - 2px);path{color:var(--color-gray-white);stroke:currentColor;stroke-width:1px;}position:absolute;top:1px;left:1px;transform:scale(0);pointer-events:none;", ":checked ~ &{transform:scale(1);animation:", " 200ms cubic-bezier(0,0.85,0.81,1.15);}"], Be, Se);
function Ae({
  id: e,
  indeterminate: t,
  checked: o,
  defaultChecked: n,
  onChange: a,
  className: l,
  style: c,
  ...d
}) {
  const [h, p] = _(o || n);
  return /* @__PURE__ */ s(Tt, { checked: o === void 0 ? h : o, className: l, style: c, children: [
    /* @__PURE__ */ r(Be, { checked: o, defaultChecked: n, id: e, onChange: (g) => {
      o === void 0 && p(g.target.checked), a && a(g);
    }, ...d }),
    /* @__PURE__ */ r(Ft, {})
  ] });
}
const $t = /* @__PURE__ */ i.div.withConfig({
  displayName: "Checkbox__CheckboxWrapper",
  componentId: "sc-1y8exo4-0"
})(["", " display:flex;align-items:center;opacity:", ";", ";"], ({
  size: e
}) => m(e === "small" ? "cell" : "body"), ({
  disabled: e
}) => e ? 0.2 : 1, ({
  disabled: e
}) => !e && `
      & label {
        cursor: pointer;
      }
    `);
function Wt({
  id: e,
  label: t,
  labelHidden: o,
  disabled: n,
  size: a,
  style: l,
  className: c,
  ...d
}) {
  return /* @__PURE__ */ s($t, { disabled: n, size: a, className: c, children: [
    /* @__PURE__ */ r(Ae, { ...d, "aria-label": t, disabled: n, id: e, style: {
      ...l,
      marginRight: "8px"
    }, title: o ? t : void 0 }),
    !o && /* @__PURE__ */ r("label", { htmlFor: e, children: t })
  ] });
}
const Et = /* @__PURE__ */ i.button.withConfig({
  displayName: "ContentCard__Wrapper",
  componentId: "sc-1pqqfam-0"
})(["background:var(--color-gray-graySLight);border:0;box-sizing:border-box;border-radius:9px;display:flex;padding:0;height:140px;flex-direction:column;box-shadow:", ";:hover{box-shadow:var(--shadow-elevate);}:hover button{background:var(--color-primaryAction-regular);color:var(--color-gray-white);}", ""], ({
  active: e
}) => e ? "var(--shadow-pressed)" : "var(--shadow-rest)", ({
  active: e
}) => !e && "cursor: pointer;"), Dt = /* @__PURE__ */ i.div.withConfig({
  displayName: "ContentCard__Header",
  componentId: "sc-1pqqfam-1"
})(["background:", ";color:", ";width:100%;border-top-left-radius:9px;border-top-right-radius:9px;padding:16px;display:flex;justify-content:space-between;align-items:center;"], ({
  active: e,
  variant: t
}) => e ? "var(--color-primaryAction-regular)" : t === "neutral" ? "var(--color-gray-grayLight)" : "var(--color-increase-light)", ({
  active: e
}) => e ? "var(--color-gray-white)" : "var(--color-gray-black)"), jt = /* @__PURE__ */ i.div.withConfig({
  displayName: "ContentCard__Body",
  componentId: "sc-1pqqfam-2"
})(["", " padding:16px;flex:1;"], ({
  theme: e
}) => e.typography.cell), Ht = /* @__PURE__ */ i.h2.withConfig({
  displayName: "ContentCard__Title",
  componentId: "sc-1pqqfam-3"
})(["", " color:", ";"], ({
  theme: e,
  titleSize: t
}) => t === "small" ? e.typography.H3 : e.typography.H2, ({
  theme: e,
  titleVariant: t
}) => t === "product" ? `var(--color-${e.productName}-regular)` : "inherit");
function Ci({
  actionText: e,
  onAction: t,
  title: o,
  titleSize: n = "normal",
  titleVariant: a = "default",
  children: l,
  active: c,
  variant: d,
  ...h
}) {
  return /* @__PURE__ */ s(Et, { ...h, active: c, onClick: t, children: [
    /* @__PURE__ */ s(Dt, { active: c, variant: d, children: [
      /* @__PURE__ */ r(Ht, { titleSize: n, titleVariant: a, children: o }),
      !c && /* @__PURE__ */ r(M, { variant: "outline", onClick: t, size: "small", children: e })
    ] }),
    /* @__PURE__ */ r(jt, { children: l })
  ] });
}
function ki({
  value: e,
  currency: t,
  language: o = navigator.language
}) {
  if (isNaN(e))
    return null;
  const n = new Intl.NumberFormat(o, {
    minimumFractionDigits: 2,
    style: "currency",
    currency: t
  });
  return /* @__PURE__ */ r(se, { children: n.format(e) });
}
const Ot = /* @__PURE__ */ i.label.withConfig({
  displayName: "Label",
  componentId: "sc-fqaupg-0"
})(["", ";display:inline-flex;flex-direction:row;font-weight:500;line-height:12px;", " white-space:nowrap;&[for]{cursor:pointer;}&[hidden]{display:none;}", ""], m("inputLabel"), ({
  inline: e
}) => !e && "margin-bottom: 6px;", ({
  required: e
}) => e ? `
          ::after {
            content: '*';
            display: inline;
            width: min-content;
            margin-left: 1px;
            color: var(--color-increase-regular);
          }
        ` : null), qt = /* @__PURE__ */ i.span.withConfig({
  displayName: "LabelError",
  componentId: "sc-frqi3-0"
})(["color:var(--color-coralAlert-regular);display:-webkit-box;font-size:13px;line-height:16px;margin-top:3px;overflow:hidden;-webkit-box-orient:vertical;-webkit-line-clamp:2;"]), Rt = /* @__PURE__ */ i.div.withConfig({
  displayName: "InputWrapper",
  componentId: "sc-3zs7st-0"
})(["", " width:", ";", ""], ({
  inline: e
}) => `
    display: ${e ? "inline-flex" : "flex"};
    align-items: ${e ? "center" : "start"};
    flex-direction: ${e ? "row" : "column"};
    ${e ? "label { margin-right: 6px; }" : ""}
  `, ({
  width: e
}) => e || "100%", ({
  error: e
}) => e && `
      label {
        color: var(--color-coralAlert-dark);
      }

      input {
        border-color: var(--color-coralAlert-regular);

        :-moz-ui-invalid {
          box-shadow: none;
        }
      }
    `), S = /* @__PURE__ */ i.input.attrs(({
  htmlSize: e,
  size: t
}) => ({
  size: e,
  controlSize: t
})).withConfig({
  displayName: "InputStyledBase",
  componentId: "sc-1d9u6g0-0"
})(["", " appearance:none;background:var(--color-gray-white);border:1px solid var(--color-gray-grayMedium);border-radius:4px;outline:none;margin:0;padding:", ";padding-left:", ";width:100%;resize:none;text-align:left;transition:border 200ms,box-shadow 200ms;:disabled{opacity:0.36;}:focus{border:1px solid var(--color-increase-light50);color:var(--color-gray-black);}::placeholder,::-webkit-input-placeholder{color:var(--color-gray-grayBold);}:focus,:focus-within{box-shadow:0 0 0 4px var(--color-increase-light);outline:0;&::-moz-focus-inner{border:0;}}:not(:disabled):hover{border:1px solid var(--color-increase-light50);}"], m("cell"), ({
  controlSize: e
}) => e === "small" ? "6px 11px" : "11px", ({
  type: e
}) => e === "search" ? "36px" : null);
function k({
  className: e,
  children: t = (x) => /* @__PURE__ */ r(S, { ...x }),
  disabled: o,
  id: n,
  label: a,
  labelHidden: l,
  type: c = "text",
  value: d,
  style: h,
  width: p,
  errorMessage: g,
  inputClassName: u,
  inputStyle: f,
  inline: b,
  required: v,
  size: I,
  ...y
}) {
  return /* @__PURE__ */ s(Rt, { className: e, error: !!g, inline: b, style: h, width: p, children: [
    !l && /* @__PURE__ */ r(Ot, { htmlFor: n, inline: b, required: v, children: a }),
    t({
      ...y,
      "aria-label": l ? a : void 0,
      className: u,
      disabled: o,
      id: n,
      name: n,
      required: v,
      size: I,
      style: f,
      title: l ? a : void 0,
      type: c,
      value: d
    }),
    g && /* @__PURE__ */ r(qt, { children: g })
  ] });
}
const Pt = (e) => /* @__PURE__ */ r(k, { ...e, type: "text" }), Gt = /* @__PURE__ */ i.div.withConfig({
  displayName: "InputSearch__IconContainer",
  componentId: "sc-117d0vl-0"
})(["--size:", ";left:8px;pointer-events:none;position:absolute;top:0;height:var(--size);width:var(--size);display:inline-flex;align-items:center;color:var(--color-gray-grayBold);*:focus-within > &{color:var(--color-gray-black);}"], ({
  size: e
}) => e === "small" ? "30px" : "40px"), Vt = /* @__PURE__ */ i.div.withConfig({
  displayName: "InputSearch__Wrapper",
  componentId: "sc-117d0vl-1"
})(["position:relative;width:100%;"]), ze = (e) => /* @__PURE__ */ r(k, { ...e, type: "search", children: (t) => /* @__PURE__ */ s(Vt, { children: [
  /* @__PURE__ */ r(S, { ...t }),
  /* @__PURE__ */ r(Gt, { size: e.size, children: /* @__PURE__ */ r(xr, { size: "24px" }) })
] }) }), Ut = /* @__PURE__ */ i.button.withConfig({
  displayName: "InputPassword__IconContainer",
  componentId: "sc-4n3v4h-0"
})(["background:transparent;border:none;cursor:pointer;height:", ";width:40px;position:absolute;right:0;text-align:center;top:0;display:inline-flex;align-items:center;"], ({
  size: e
}) => e === "small" ? "30px" : "40px"), Yt = /* @__PURE__ */ i.div.withConfig({
  displayName: "InputPassword__Wrapper",
  componentId: "sc-4n3v4h-1"
})(["position:relative;width:100%;"]), Ii = (e) => {
  const [t, o] = _(!0), n = () => (t && e.onShowPassword && e.onShowPassword(), o(!t));
  return /* @__PURE__ */ r(se, { children: /* @__PURE__ */ r(k, { ...e, type: t === !0 ? "password" : "text", children: (a) => /* @__PURE__ */ s(Yt, { children: [
    /* @__PURE__ */ r(S, { ...a }),
    /* @__PURE__ */ r(Ut, { "aria-label": "toggle show password", onClick: n, size: e.size, type: "button", children: t === !0 ? /* @__PURE__ */ r(ur, { size: "22px" }) : /* @__PURE__ */ r(mr, { size: "22px" }) })
  ] }) }) });
}, Kt = /* @__PURE__ */ i.div.withConfig({
  displayName: "InputNumber__InputContainer",
  componentId: "sc-14jmtnn-0"
})(["display:inline-flex;position:relative;width:100%;.prefix{display:flex;align-items:center;font-size:13px;height:100%;line-height:14px;justify-content:center;position:absolute;width:24px;}"]), Xt = /* @__PURE__ */ i(S).withConfig({
  displayName: "InputNumber__InputStyled",
  componentId: "sc-14jmtnn-1"
})(["padding-right:6px;padding-left:", ";"], ({
  prefix: e
}) => e ? "20px" : "12px"), q = ({
  prefix: e,
  ...t
}) => {
  const o = (n) => {
    n.target.blur();
  };
  return /* @__PURE__ */ r(k, { ...t, children: (n) => /* @__PURE__ */ r(C, { children: /* @__PURE__ */ s(Kt, { children: [
    e && /* @__PURE__ */ r("span", { className: "prefix", children: e }),
    /* @__PURE__ */ r(Xt, { ...n, type: "number", onWheel: o, prefix: e })
  ] }) }) });
}, Ni = (e) => /* @__PURE__ */ r(k, { as: "textarea", ...e }), Jt = /* @__PURE__ */ i.div.withConfig({
  displayName: "InputFile__InputControlWrapper",
  componentId: "sc-gj7a56-0"
})(["width:100%;position:relative;display:flex;"]), Qt = /* @__PURE__ */ i.input.withConfig({
  displayName: "InputFile__Input",
  componentId: "sc-gj7a56-1"
})(["opacity:0;position:absolute;top:0;left:0;height:100%;width:100%;"]), Zt = /* @__PURE__ */ i(S).withConfig({
  displayName: "InputFile__InputSubstitute",
  componentId: "sc-gj7a56-2"
})(["height:40px;display:flex;justify-content:space-between;align-items:center;padding:0;input:disabled + &{opacity:0.16;}input:not(:disabled):hover + &{border:1px solid var(--color-gray-black);}"]), eo = /* @__PURE__ */ i.div.withConfig({
  displayName: "InputFile__ValueContainer",
  componentId: "sc-gj7a56-3"
})(["padding:8px;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]), ro = /* @__PURE__ */ i(K).withConfig({
  displayName: "InputFile__InnerLabel",
  componentId: "sc-gj7a56-4"
})(["font-weight:bold;min-width:max-content;border-top-right-radius:4px;border-bottom-right-radius:4px;background:var(--color-primaryAction-regular);color:var(--color-gray-white);display:flex;justify-content:center;align-items:center;padding:0 8px;height:calc(100% + 2px);margin:-1px;input:hover + * &{box-shadow:1px 2px 3px rgba(15,107,255,0.27),1px 2px 2px rgba(15,107,255,0.36);}"]), Mi = ({
  innerLabel: e,
  onChange: t,
  noFilesText: o = "Ningún archivo seleccionado",
  selectedFileText: n,
  accept: a,
  ...l
}) => {
  const c = (d) => {
    d && d.length > 0 && t(d[0]);
  };
  return /* @__PURE__ */ r(k, { ...l, children: (d) => /* @__PURE__ */ s(Jt, { children: [
    /* @__PURE__ */ r(Qt, { ...d, accept: a && a.join(","), onChange: (h) => c(h.target.files), type: "file" }),
    /* @__PURE__ */ s(Zt, { as: "label", disabled: d.disabled, htmlFor: d.id, size: "normal", children: [
      /* @__PURE__ */ r(eo, { children: n || o }),
      /* @__PURE__ */ r(ro, { children: e || /* @__PURE__ */ r(Cr, { size: "24" }) })
    ] })
  ] }) });
}, Le = /* @__PURE__ */ i(fr).attrs({
  prev2Label: null,
  next2Label: null,
  prevLabel: /* @__PURE__ */ r(ue, { size: "24" }),
  nextLabel: /* @__PURE__ */ r(me, { size: "24" }),
  calendarType: "US",
  formatShortWeekday: (e, t) => G(t, "EEEEE", {
    locale: P
  }).toLocaleUpperCase(),
  navigationLabel: ({
    date: e
  }) => G(e, "MMMM Y", {
    locale: P
  })
}).withConfig({
  displayName: "Datepicker",
  componentId: "sc-vpw7fc-0"
})(["background:var(--color-gray-white);border:1px solid var(--color-gray-grayMedium);border-radius:4px;padding:12px 8px;width:300px;box-shadow:var(--shadow-rest);button{background:transparent;border:none;}.react-calendar__navigation__label{", " text-transform:capitalize;}.react-calendar__navigation{display:flex;align-items:center;margin-bottom:16px;justify-content:flex-start;}.react-calendar__navigation__arrow{&:not(:disabled){cursor:pointer;}}.react-calendar__navigation__arrow:hover{color:var(--color-primaryAction-regular);}.react-calendar__navigation__label:not(:disabled){cursor:pointer;}.react-calendar__year-view__months__month,.react-calendar__decade-view__years__year,.react-calendar__century-view__decades__decade{", " text-transform:capitalize;padding:8px 0;> abbr{padding:4px;border:1px solid transparent;}}.react-calendar__month-view__weekdays__weekday{", " display:inline-flex;justify-content:center;align-items:center;> abbr{text-decoration:none;}}.react-calendar__month-view__days__day,.react-calendar__year-view__months__month,.react-calendar__year-view__yeart__year,.react-calendar__year-view__decades__decade{&:not(:disabled){cursor:pointer;}}.react-calendar__tile.react-calendar__month-view__days__day{", " height:27px;width:27px;margin:2px 0;padding:0 6px;> abbr{height:100%;width:100%;border-radius:3px;display:inline-flex;justify-content:center;align-items:center;}&.react-calendar__tile--rangeEnd > abbr,&.react-calendar__tile--rangeStart > abbr{border-radius:3px;}}.react-calendar__tile.react-calendar__year-view__months__month{", " > abbr{height:100%;width:100%;display:inline-flex;justify-content:center;align-items:center;}&.react-calendar__tile--rangeEnd > abbr{border-top-right-radius:3px;border-bottom-right-radius:3px;}&.react-calendar__tile--rangeStart > abbr{border-top-left-radius:3px;border-bottom-left-radius:3px;}&.react-calendar__tile--rangeStart ~ .react-calendar__tile--active,&.react-calendar__tile--rangeStart ~ .react-calendar__tile--hasActive{> abbr{background:var(--color-increase-light70);color:var(--color-increase-dark);}}&.react-calendar__tile--hasActive > abbr,&.react-calendar__tile--rangeStart.react-calendar__tile--active > abbr,&.react-calendar__tile--rangeStart.react-calendar__tile--hasActive > abbr,&.react-calendar__tile--rangeEnd.react-calendar__tile--active > abbr,&.react-calendar__tile--rangeEnd.react-calendar__tile--hasActive > abbr{background:var(--color-increase-regular);color:var(--color-gray-white);}}.react-calendar__tile--rangeStart.react-calendar__tile--active > abbr,.react-calendar__tile--rangeStart.react-calendar__tile--hasActive > abbr,.react-calendar__tile--rangeEnd.react-calendar__tile--active > abbr,.react-calendar__tile--rangeEnd.react-calendar__tile--hasActive > abbr{background:var(--color-increase-regular);color:var(--color-gray-white);}.react-calendar__tile.react-calendar__month-view__days__day{&.react-calendar__tile--rangeStart ~ .react-calendar__tile--active,&.react-calendar__tile--rangeStart ~ .react-calendar__tile--hasActive{background:var(--color-increase-light70);color:var(--color-increase-dark);&:nth-child(7n){border-top-right-radius:3px;border-bottom-right-radius:3px;}&:nth-child(7n + 1){border-top-left-radius:3px;border-bottom-left-radius:3px;}}&.react-calendar__tile--rangeStart.react-calendar__tile--active,&.react-calendar__tile--rangeStart.react-calendar__tile--hasActive{background:linear-gradient(90deg,transparent 50%,var(--color-increase-light70) 50%);}&.react-calendar__tile--rangeEnd.react-calendar__tile--hasActive,&.react-calendar__tile--rangeEnd.react-calendar__tile--active{background:linear-gradient(-90deg,transparent 50%,var(--color-increase-light70) 50%);}&.react-calendar__tile--rangeBothEnds.react-calendar__tile--active,&.react-calendar__tile--rangeBothEnds.react-calendar__tile--hasActive{background:transparent;}&.react-calendar__month-view__days__day--neighboringMonth{opacity:0.45;color:var(--color-gray-black);}&.react-calendar__month-view__days__day:disabled{opacity:0.16;color:var(--color-gray-black);}}.react-calendar__tile--now:not(.react-calendar__tile--hasActive):not( .react-calendar__tile--active ) > abbr{border:1px solid var(--color-increase-dark);border-radius:3px;}.react-calendar__tile--hover{background:var(--color-increase-light);}"], m("body"), m("cell"), m("body"), m("cell"), m("cell"));
function to(e, t) {
  return e && (typeof e == "string" ? w(ge(e), t) : w(e, t));
}
const oo = /* @__PURE__ */ i.div.withConfig({
  displayName: "DateInput__Wrapper",
  componentId: "sc-5vrpd9-0"
})(["position:relative;width:100%;"]), no = /* @__PURE__ */ i.div.withConfig({
  displayName: "DateInput__IconWrapper",
  componentId: "sc-5vrpd9-1"
})(["position:absolute;left:4px;pointer-events:none;top:0;margin:4px 0;height:calc(100% - 8px);width:", ";display:flex;justify-content:center;align-items:center;color:var(--color-gray-blackLight);", " *:focus-within ~ &{border-right:1px solid transparent;border-radius:4px;color:var(--color-increase-regular);background:var(--color-gray-grayLight);}"], ({
  size: e
}) => e === "small" ? "24px" : "34px", ({
  size: e
}) => e !== "small" && `
      border-right: 1px solid var(--color-gray-grayMedium);
    `);
function Te({
  className: e,
  value: t,
  onChange: o,
  dateFormat: n = "dd/MM/yyyy",
  datepickerProps: a = {},
  emptyMessage: l,
  ...c
}) {
  const d = l || n.toLowerCase(), h = to(t, n) || d;
  return /* @__PURE__ */ r(A, { className: e, renderTrigger: (p, {
    setShowMenu: g
  }) => /* @__PURE__ */ r(k, { ...c, ...p, inputStyle: {
    paddingLeft: c.size === "small" ? "32px" : "48px"
  }, onFocus: () => g(!0), readOnly: !0, value: h, children: (u) => /* @__PURE__ */ s(oo, { children: [
    /* @__PURE__ */ r(S, { ...u, readOnly: !0 }),
    /* @__PURE__ */ r(no, { size: c.size, children: /* @__PURE__ */ r(fe, { size: c.size === "small" ? "16" : "20" }) })
  ] }) }), children: ({
    toggleShowMenu: p
  }) => /* @__PURE__ */ r("div", { role: "menu", style: {
    position: "absolute",
    top: "4px"
  }, children: /* @__PURE__ */ r(Le, { ...a, onChange: (g) => {
    p(), o && o(g);
  }, value: typeof t == "string" ? ge(t) : t }) }) });
}
function io({
  uncontrolled: e,
  ...t
}) {
  const [o, n] = _(/* @__PURE__ */ new Date());
  return /* @__PURE__ */ r(Te, { ...t, onChange: n, value: o });
}
function ao(e) {
  return e.uncontrolled === !0 ? /* @__PURE__ */ r(io, { ...e }) : /* @__PURE__ */ r(Te, { ...e });
}
const lo = /* @__PURE__ */ i.div.withConfig({
  displayName: "DateRangeInput__IconWrapper",
  componentId: "sc-fzt752-0"
})(["position:absolute;left:4px;pointer-events:none;top:0;margin:4px 0;height:calc(100% - 8px);width:", ";display:flex;justify-content:center;align-items:center;color:var(--color-gray-blackLight);", " *:focus-within ~ &{border-right:1px solid transparent;border-radius:4px;color:var(--color-increase-regular);background:var(--color-gray-grayLight);}"], ({
  size: e
}) => e === "small" ? "24px" : "34px", ({
  size: e
}) => e !== "small" && `
      border-right: 1px solid var(--color-gray-grayMedium);
    `), co = /* @__PURE__ */ i.div.withConfig({
  displayName: "DateRangeInput__Wrapper",
  componentId: "sc-fzt752-1"
})(["position:relative;width:100%;"]);
function so({
  value: e,
  onChange: t,
  dateFormat: o = "dd/MM/yyyy",
  datepickerProps: n = {},
  emptyMessage: a,
  ...l
}) {
  const c = !e || e.filter((h) => !!h).length === 0, d = a || `${o.toLowerCase()} - ${o.toLowerCase()}`;
  return /* @__PURE__ */ r(A, { renderTrigger: (h, {
    setShowMenu: p
  }) => /* @__PURE__ */ r(k, { ...l, ...h, inputStyle: {
    paddingLeft: l.size === "small" ? "32px" : "48px"
  }, onFocus: () => p(!0), readOnly: !0, value: c ? d : e.map((g) => G(g, o)).join(" - "), children: (g) => /* @__PURE__ */ s(co, { children: [
    /* @__PURE__ */ r(S, { ...g }),
    /* @__PURE__ */ r(lo, { size: l.size, children: /* @__PURE__ */ r(fe, { size: l.size === "small" ? "16" : "20" }) })
  ] }) }), children: ({
    toggleShowMenu: h
  }) => /* @__PURE__ */ r("div", { role: "menu", style: {
    position: "absolute",
    top: "4px"
  }, children: /* @__PURE__ */ r(Le, { ...n, onChange: (p) => {
    h(), t(p);
  }, selectRange: !0, value: e, defaultActiveStartDate: /* @__PURE__ */ new Date() }) }) });
}
const po = [{
  value: "equals",
  name: "Es igual a"
}, {
  value: "contains",
  name: "Contiene"
}], Fe = [{
  value: "equals",
  name: "Es igual a"
}, {
  value: "between",
  name: "Está entre"
}, {
  value: "greaterThan",
  name: "Mayor que"
}, {
  value: "lowerThan",
  name: "Menor que"
}], ho = /* @__PURE__ */ i.select.withConfig({
  displayName: "NativeSelect__SelectInput",
  componentId: "sc-1w11wk4-0"
})(["", " height:", ";padding:", ";border:1px solid var(--color-gray-grayMedium);border-radius:4px;vertical-align:middle;appearance:none;background:var(--color-gray-white);margin:0;outline:0;text-align:inherit;position:relative;width:100%;transition:all 200ms;:focus{box-shadow:0 0 0 4px var(--color-increase-light);outline:0;&::-moz-focus-inner{border:0;}}&:active,&:focus{border:1px solid var(--color-increase-light50)};}"], m("cell"), ({
  size: e
}) => e === "small" ? "30px" : "40px", ({
  size: e
}) => e === "small" ? "6px 49px 6px 11px" : "11px 49px 11px 11px"), go = /* @__PURE__ */ i.div.withConfig({
  displayName: "NativeSelect__ArrowWrapper",
  componentId: "sc-1w11wk4-1"
})(["--size:", ";position:absolute;right:3px;bottom:3px;display:flex;justify-content:center;align-items:center;height:var(--size);width:var(--size);border-left:1px solid var(--color-gray-grayMedium);pointer-events:none;select:focus-within ~ &,select:active ~ &{background-color:var(--color-gray-grayLight);border-left:1px solid transparent;border-radius:4px;}"], ({
  size: e
}) => e === "small" ? "24px" : "34px"), uo = /* @__PURE__ */ i.div.withConfig({
  displayName: "NativeSelect__InputWrapper",
  componentId: "sc-1w11wk4-2"
})(["position:relative;width:100%;"]);
function Q({
  children: e,
  ...t
}) {
  return /* @__PURE__ */ r(k, { ...t, children: (o) => /* @__PURE__ */ s(uo, { children: [
    /* @__PURE__ */ r(ho, { ...o, children: e }),
    /* @__PURE__ */ r(go, { size: o.size, children: /* @__PURE__ */ r(j, { size: "24" }) })
  ] }) });
}
function Si(e) {
  return /* @__PURE__ */ r("optgroup", { ...e });
}
function Bi(e) {
  return /* @__PURE__ */ r("option", { ...e });
}
function Z(e, t) {
  return t === void 0 ? !0 : Object.entries(t.enabledKinds).filter(([, o]) => o).map(([o]) => o).includes(e);
}
const mo = {
  equals: (e) => ({
    field: e,
    kind: "equals",
    value: w(/* @__PURE__ */ new Date(), "dd/MM/yyyy")
  }),
  greaterThan: (e) => ({
    field: e,
    kind: "greaterThan",
    value: w(/* @__PURE__ */ new Date(), "dd/MM/yyyy")
  }),
  lowerThan: (e) => ({
    field: e,
    kind: "lowerThan",
    value: w(/* @__PURE__ */ new Date(), "dd/MM/yyyy")
  }),
  between: (e) => ({
    field: e,
    kind: "between",
    value: {
      from: w(/* @__PURE__ */ new Date(), "dd/MM/yyyy"),
      to: w(/* @__PURE__ */ new Date(), "dd/MM/yyyy")
    }
  })
};
function fo(e) {
  return [re(e.from, "dd/MM/yyyy", /* @__PURE__ */ new Date()), re(e.to, "dd/MM/yyyy", /* @__PURE__ */ new Date())];
}
function bo({
  label: e,
  onChange: t,
  value: o,
  ...n
}) {
  const a = Fe.filter(({
    value: l
  }) => Z(l, o.field.config));
  return /* @__PURE__ */ s(D, { rowGap: 1, ...n, children: [
    /* @__PURE__ */ r(Q, { label: e, labelHidden: !0, onChange: (l) => {
      const c = l.target.value, d = mo[c](o.field);
      t(d);
    }, size: "small", value: o.kind, children: a.map(({
      value: l,
      name: c
    }) => /* @__PURE__ */ r("option", { value: l, children: c }, c)) }),
    o.kind === "between" ? /* @__PURE__ */ r(so, { id: `filter.${o.field.name}.value`, label: e, labelHidden: !0, onChange: (l) => {
      t({
        ...o,
        value: {
          from: w(l[0], "dd/MM/yyyy"),
          to: w(l[1], "dd/MM/yyyy")
        }
      });
    }, size: "small", value: fo(o.value) }) : /* @__PURE__ */ r(ao, { id: `filter.${o.field.name}.value`, label: e, labelHidden: !0, onChange: (l) => {
      t({
        ...o,
        value: w(l, "dd/MM/yyyy")
      });
    }, size: "small", value: o.value })
  ] });
}
const F = /* @__PURE__ */ i.div.withConfig({
  displayName: "styles__OptionsStack",
  componentId: "sc-1l9h0um-0"
})(["display:flex;flex-direction:column;background:var(--color-gray-white);overflow-y:auto;overflow-x:hidden;"]), $e = /* @__PURE__ */ i(F).withConfig({
  displayName: "styles__SelectBoxWrapper",
  componentId: "sc-1l9h0um-1"
})(["gap:6px;max-height:250px;max-width:250px;"]), yo = /* @__PURE__ */ i(F).withConfig({
  displayName: "styles__Menu",
  componentId: "sc-1l9h0um-2"
})(["padding:4px;position:absolute;top:4px;max-height:250px;border-radius:4px;border:1px solid var(--color-gray-grayMedium);box-shadow:var(--shadow-elevateCast);"]), xo = /* @__PURE__ */ i(S).attrs({
  as: "button",
  type: "button"
}).withConfig({
  displayName: "styles__FakeInput",
  componentId: "sc-1l9h0um-3"
})(["width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding-right:40px;cursor:pointer;"]), vo = /* @__PURE__ */ i(K).attrs({
  as: "label"
}).withConfig({
  displayName: "styles__Label",
  componentId: "sc-1l9h0um-4"
})(["display:inline-flex;gap:0.5rem;width:calc(100%);padding:4px;cursor:pointer;", " ", " :hover{background:var(--color-increase-light);}"], ({
  hidden: e
}) => e && "display: none;", ({
  isSelected: e
}) => e && "background: var(--color-increase-light);"), We = /* @__PURE__ */ i.span.withConfig({
  displayName: "styles__OptionName",
  componentId: "sc-1l9h0um-5"
})(["max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]), wo = /* @__PURE__ */ i.div.withConfig({
  displayName: "styles__InputWrapper",
  componentId: "sc-1l9h0um-6"
})(["position:relative;width:100%;"]), _o = /* @__PURE__ */ i.div.withConfig({
  displayName: "styles__ArrowWrapper",
  componentId: "sc-1l9h0um-7"
})(["position:absolute;right:3px;bottom:3px;display:flex;justify-content:center;align-items:center;height:", ";width:", ";border-left:1px solid var(--color-gray-grayMedium);pointer-events:none;select:focus-within ~ &,select:active ~ &{background-color:var(--color-gray-grayLight);border-left:1px solid transparent;border-radius:4px;}"], ({
  size: e
}) => e === "small" ? "24px" : "34px", ({
  size: e
}) => e === "small" ? "24px" : "34px"), Ee = /* @__PURE__ */ i.hr.withConfig({
  displayName: "styles__Separator",
  componentId: "sc-1l9h0um-8"
})(["border:0;border-top:1px solid var(--color-gray-grayMedium);margin:8px 0;"]), De = /* @__PURE__ */ i.div.withConfig({
  displayName: "styles__MenuHeader",
  componentId: "sc-1l9h0um-9"
})(["padding:4px;"]), Co = /* @__PURE__ */ i(_e).withConfig({
  displayName: "styles__SelectionButton",
  componentId: "sc-1l9h0um-10"
})(["", " :not(:first-child){margin-top:8px;}"], ({
  theme: e
}) => e.typography.cell), ko = /* @__PURE__ */ i.button.attrs({
  role: "menuitem"
}).withConfig({
  displayName: "styles__OptionButton",
  componentId: "sc-1l9h0um-11"
})(["", " border:0;border-radius:4px;padding:6px;text-align:left;background:var(--color-gray-white);", " :not(:disabled){cursor:pointer;}:hover,&.selected{background:var(--color-increase-light);}"], ({
  theme: e
}) => e.typography.cell, ({
  hidden: e
}) => e && "display: none;"), Io = {
  width: "100%"
};
function je({
  selectionText: e,
  children: t,
  options: o,
  value: n,
  onChange: a,
  onSearch: l,
  hasSearch: c,
  localSearch: d,
  selectAllButton: h,
  ...p
}) {
  const g = d || c;
  return /* @__PURE__ */ r(k, { ...p, children: ({
    id: u,
    ...f
  }) => /* @__PURE__ */ r(A, { onmountOnHide: !0, renderTrigger: (b, {
    toggleShowMenu: v
  }) => /* @__PURE__ */ s(wo, { ...b, children: [
    /* @__PURE__ */ r(xo, { onClick: v, size: p.size, title: e, children: e }),
    /* @__PURE__ */ r(_o, { size: p.size, children: /* @__PURE__ */ r(j, { size: "24" }) })
  ] }), style: Io, ...p, children: ({
    wrapperRef: b,
    toggleShowMenu: v
  }) => /* @__PURE__ */ r(yo, { style: {
    width: b.current?.getBoundingClientRect().width
  }, children: t({
    inputProps: f,
    toggleShowMenu: v,
    localSearch: g
  }) }) }) });
}
const No = ({
  options: e,
  value: t,
  search: o,
  onChange: n,
  inputProps: a
}) => e.map(({
  name: l,
  value: c
}) => {
  const d = !!t.find((h) => h.value === c);
  return /* @__PURE__ */ s(vo, { hidden: o ? !l.toLocaleLowerCase().includes(o.toLocaleLowerCase()) : !1, htmlFor: c, title: l, isSelected: d, children: [
    /* @__PURE__ */ r(Ae, { ...a, checked: d, id: c, "data-name": l, onChange: (h) => {
      const p = h.target;
      let g;
      p.checked ? g = [...t, {
        name: l,
        value: c
      }] : g = t.filter((u) => u.value !== p.value), n && n(g, h);
    }, value: c }),
    /* @__PURE__ */ r(We, { children: l })
  ] }, c);
}), Mo = ({
  options: e,
  search: t,
  onClick: o,
  selected: n
}) => e.map(({
  name: a,
  value: l
}) => /* @__PURE__ */ r(ko, { className: n === l ? "selected" : "", hidden: !!t && !a.toLocaleLowerCase().includes(t.toLocaleLowerCase()), "data-name": a, onClick: (c) => o && o(l, {
  name: a,
  value: l
}, c), children: /* @__PURE__ */ r(We, { children: a }) }, l)), He = ({
  onSearch: e,
  onChange: t,
  options: o,
  value: n,
  localSearch: a,
  inputProps: l
}) => {
  const [c, d] = _("");
  return /* @__PURE__ */ s(F, { children: [
    (e || a) && /* @__PURE__ */ s(De, { children: [
      /* @__PURE__ */ r(ze, { id: "search", label: "Buscar", size: "small", labelHidden: !0, onChange: (p) => {
        a && d(p.target.value), e && e(p.target.value);
      }, placeholder: "Buscar" }),
      /* @__PURE__ */ r(Ee, {})
    ] }),
    /* @__PURE__ */ r(F, { children: /* @__PURE__ */ r(Mo, { selected: n, options: o, search: c, onClick: (p, g, u) => t && t(p, g, u), ...l }) })
  ] });
}, Ai = (e) => /* @__PURE__ */ s($e, { children: [
  /* @__PURE__ */ r(X, { children: e.label }),
  /* @__PURE__ */ r(He, { ...e })
] });
function So({
  options: e,
  value: t,
  onChange: o,
  ...n
}) {
  const a = e.find((l) => l.value === t)?.name || "Ninguno seleccionado";
  return /* @__PURE__ */ r(je, { options: e, value: t, selectionText: a, ...n, children: ({
    toggleShowMenu: l,
    localSearch: c,
    inputProps: d
  }) => /* @__PURE__ */ r(He, { onChange: (h, p, g) => {
    o && o(h, p, g), l();
  }, localSearch: c, onSearch: n.onSearch, options: e, value: t, size: "small", inputProps: d }) });
}
const Oe = ({
  options: e,
  value: t,
  onSearch: o,
  onChange: n,
  onToggleAll: a,
  localSearch: l,
  inputProps: c,
  hasClearButton: d,
  clearButtonText: h = "Limpiar seleccionados",
  selectAllButtonText: p = "Seleccionar todo"
}) => {
  const [g, u] = _(""), f = e.length === t.length, b = l || o;
  return /* @__PURE__ */ s(F, { children: [
    (b || d) && /* @__PURE__ */ s(De, { children: [
      b && /* @__PURE__ */ r(ze, { id: "search", label: "Buscar", size: "small", labelHidden: !0, onChange: (y) => {
        l && u(y.target.value), o && o(y.target.value);
      }, placeholder: "Buscar" }),
      d && /* @__PURE__ */ r(Co, { onClick: () => {
        if (a) {
          const y = f ? [] : [...e];
          a(y);
        }
      }, children: f ? h : p }),
      /* @__PURE__ */ r(Ee, {})
    ] }),
    /* @__PURE__ */ r(F, { children: /* @__PURE__ */ r(No, { id: "options-menu", onChange: (y, x) => n && n(y, x), value: t, options: e, search: g, inputProps: c }) })
  ] });
}, zi = (e) => /* @__PURE__ */ s($e, { children: [
  /* @__PURE__ */ r(X, { children: e.label }),
  /* @__PURE__ */ r(Oe, { ...e })
] });
function Bo(e, t) {
  if (e.length === 0 || !e) return "Ninguno seleccionado";
  if (e.length > 0 && e.length === t.length)
    return "Todos seleccionados";
  const o = e.map(({
    name: n
  }) => n);
  return o.length === 1 ? o[0] : o.length === 2 ? o.join(" y ") : `${o.slice(0, 2).join(", ")} y ${o.length - 2} más`;
}
function Ao({
  options: e,
  value: t,
  onChange: o,
  onToggleAll: n,
  renderSelection: a = Bo,
  clearButtonText: l,
  selectAllButtonText: c,
  hasClearButton: d,
  ...h
}) {
  const p = a(t, e);
  return /* @__PURE__ */ r(je, { options: e, value: t, ...h, selectionText: p, children: ({
    inputProps: g
  }) => /* @__PURE__ */ r(Oe, { options: e, value: t, onChange: (u, f) => o && o(u, f), localSearch: h.localSearch, onSearch: h.onSearch, size: "small", inputProps: g }) });
}
function zo({
  value: e,
  label: t,
  onChange: o,
  ...n
}) {
  return /* @__PURE__ */ r("div", { ...n, children: /* @__PURE__ */ r(So, { id: `filter.${e.field.name}.value`, label: t, labelHidden: !0, options: e.field.options, onSearch: e.field.onSearch, localSearch: e.field.localSearch || e.field.hasSearch, onChange: (a) => {
    o({
      ...e,
      value: a
    });
  }, required: !0, size: "small", value: e.value }) });
}
function Lo({
  value: e,
  label: t,
  onChange: o,
  ...n
}) {
  const a = po.filter(({
    value: l
  }) => Z(l, e.field.config));
  return /* @__PURE__ */ s(D, { rowGap: 1, ...n, children: [
    /* @__PURE__ */ r(Q, { label: t, labelHidden: !0, onChange: (l) => {
      const c = l.target.value;
      o({
        ...e,
        kind: c
      });
    }, size: "small", value: e.kind, children: a.map(({
      value: l,
      name: c
    }) => /* @__PURE__ */ r("option", { value: l, children: c }, c)) }),
    /* @__PURE__ */ r(Pt, { id: `filter.${e.field.name}.value`, label: t, labelHidden: !0, onChange: (l) => {
      const c = l.target.value;
      o({
        ...e,
        value: c
      });
    }, required: !0, size: "small", value: e.value })
  ] });
}
const To = {
  equals: (e) => ({
    field: e,
    kind: "equals",
    value: 0
  }),
  greaterThan: (e) => ({
    field: e,
    kind: "greaterThan",
    value: 0
  }),
  lowerThan: (e) => ({
    field: e,
    kind: "lowerThan",
    value: 0
  }),
  between: (e) => ({
    field: e,
    kind: "between",
    value: {
      from: 0,
      to: 0
    }
  })
};
function Fo({
  label: e,
  onChange: t,
  value: o,
  ...n
}) {
  const a = Fe.filter(({
    value: l
  }) => Z(l, o.field.config));
  return /* @__PURE__ */ s(D, { rowGap: 1, ...n, children: [
    /* @__PURE__ */ r(Q, { label: e, labelHidden: !0, onChange: (l) => {
      const c = l.target.value;
      t(To[c](o.field));
    }, size: "small", value: o.kind, children: a.map(({
      value: l,
      name: c
    }) => /* @__PURE__ */ r("option", { value: l, children: c }, c)) }),
    o.kind === "between" ? /* @__PURE__ */ s("div", { style: {
      display: "grid",
      gridTemplateColumns: "repeat(3, auto)",
      gridColumnGap: "8px",
      alignItems: "center"
    }, children: [
      /* @__PURE__ */ r(q, { id: `filter.${o.field.name}.value.from`, label: e, labelHidden: !0, onChange: (l) => {
        const c = l.target.value;
        t({
          ...o,
          value: {
            ...o.value,
            from: parseFloat(c)
          }
        });
      }, size: "small", value: o.value.from }),
      "y",
      /* @__PURE__ */ r(q, { id: `filter.${o.field.name}.value.to`, label: e, labelHidden: !0, onChange: (l) => {
        const c = l.target.value;
        t({
          ...o,
          value: {
            ...o.value,
            to: parseFloat(c)
          }
        });
      }, size: "small", value: o.value.to })
    ] }) : /* @__PURE__ */ r(q, { id: `filter.${o.field.name}.value`, label: e, labelHidden: !0, onChange: (l) => {
      const c = l.target.value;
      t({
        ...o,
        value: parseFloat(c)
      });
    }, size: "small", value: o.value })
  ] });
}
function $o({
  value: e,
  label: t,
  onChange: o,
  ...n
}) {
  return /* @__PURE__ */ r(Ao, { hasClearButton: e.field.hasClearButton, localSearch: e.field.localSearch || e.field.hasSearch, onSearch: e.field.onSearch, id: `filter.${e.field.name}.value`, label: t, labelHidden: !0, onChange: (a) => {
    o({
      ...e,
      value: a
    });
  }, options: e.field.options, renderSelection: e.field.renderSelection, size: "small", value: e.value, ...n });
}
function Wo({
  label: e,
  onChange: t,
  value: o,
  ...n
}) {
  switch (o.field.type) {
    case "select":
      return /* @__PURE__ */ r(zo, { label: e, onChange: t, value: o, ...n });
    case "selectMultiple":
      return /* @__PURE__ */ r($o, { label: e, onChange: t, value: o, ...n });
    case "text":
      return /* @__PURE__ */ r(Lo, { label: e, onChange: t, value: o, ...n });
    case "number":
      return /* @__PURE__ */ r(Fo, { label: e, onChange: t, value: o, ...n });
    case "date":
      return /* @__PURE__ */ r(bo, { label: e, onChange: t, value: o, ...n });
    default:
      return null;
  }
}
const Eo = /* @__PURE__ */ i.div.withConfig({
  displayName: "FilterControl__FilterControlWrapper",
  componentId: "sc-dqohou-0"
})(["padding:6px 0;"]), Do = /* @__PURE__ */ i.div.withConfig({
  displayName: "FilterControl__FilterInputWrapper",
  componentId: "sc-dqohou-1"
})(["margin-top:6px;padding-left:24px;"]), jo = /* @__PURE__ */ i.div.withConfig({
  displayName: "FilterControl__Row",
  componentId: "sc-dqohou-2"
})(["display:flex;"]);
function qe(e) {
  switch (e.type) {
    case "date":
      return {
        value: w(/* @__PURE__ */ new Date(), "dd/MM/yyyy"),
        kind: "equals",
        field: e
      };
    case "number":
      return {
        value: 0,
        kind: "equals",
        field: e
      };
    case "text":
      return {
        value: "",
        kind: "equals",
        field: e
      };
    case "select":
      return {
        value: e.options[0].value,
        field: e
      };
    case "selectMultiple":
      return {
        value: [],
        field: e
      };
    default:
      throw new Error("invalid field");
  }
}
function Ho({
  onChange: e,
  value: t
}) {
  const o = `Filtrar por ${t.field.name}`, n = `filter.${t.field.name}.enabled`;
  return /* @__PURE__ */ s(Eo, { children: [
    /* @__PURE__ */ s(jo, { children: [
      /* @__PURE__ */ r(Wt, { checked: t.enabled, disabled: t.field.config?.required, id: n, label: o, labelHidden: !0, onChange: () => t.enabled ? e({
        ...t,
        enabled: !1
      }) : e({
        ...t,
        enabled: !0,
        filter: qe(t.field)
      }) }),
      /* @__PURE__ */ r(K, { as: "label", htmlFor: n, weight: "bold", children: t.field.displayName })
    ] }),
    /* @__PURE__ */ r(Do, { children: t.enabled && /* @__PURE__ */ r(Wo, { label: o, onChange: (a) => {
      e({
        ...t,
        filter: a
      });
    }, value: t.filter }) })
  ] });
}
const Oo = /* @__PURE__ */ i(M).withConfig({
  displayName: "FilterButton__FilterButtonTrigger",
  componentId: "sc-1t7tuk1-0"
})(["", ""], ({
  active: e
}) => e && "background: var(--color-primaryAction-alpha);"), qo = /* @__PURE__ */ i.div.attrs({
  role: "menu"
}).withConfig({
  displayName: "FilterButton__Menu",
  componentId: "sc-1t7tuk1-1"
})(["background:var(--color-gray-white);box-shadow:var(--shadow-elevateCast);border:1px solid var(--color-gray-grayMedium);border-radius:4px;position:absolute;top:4px;animation:", " 100ms ease-in;min-width:280px;text-align:left;left:0;padding:8px;"], J), Ro = /* @__PURE__ */ i.div.withConfig({
  displayName: "FilterButton__MenuFooter",
  componentId: "sc-1t7tuk1-2"
})(["border-top:1px solid var(--color-gray-grayMedium);padding:8px 0 0;display:flex;justify-content:space-between;"]), Po = /* @__PURE__ */ i.div.withConfig({
  displayName: "FilterButton__MenuBody",
  componentId: "sc-1t7tuk1-3"
})([""]), Go = (e) => Object.entries(e).reduce((t, [o, n]) => (n.field.config?.required && (t[o] = n), t), {});
function Li({
  className: e,
  fields: t,
  value: o,
  onChange: n
}) {
  const [a, l] = _(o), d = Object.entries(o).length;
  return /* @__PURE__ */ r("div", { className: e, children: /* @__PURE__ */ r(A, { closeOnClickOutside: !0, onClickOutside: () => l(o), onmountOnHide: !1, renderTrigger: (h, {
    toggleShowMenu: p,
    showMenu: g
  }) => /* @__PURE__ */ r(Oo, { ...h, active: g, buttonType: "invisible", icon: d > 0 ? /* @__PURE__ */ r(yr, {}) : /* @__PURE__ */ r(br, {}), onClick: p, children: d > 0 ? `${d} filtros` : "Filtrar" }), children: ({
    toggleShowMenu: h
  }) => /* @__PURE__ */ s(qo, { as: "form", onSubmit: (p) => {
    n(a), h(), p.preventDefault();
  }, children: [
    /* @__PURE__ */ r(Po, { children: t.map((p) => /* @__PURE__ */ r(Ho, { onChange: (g) => l((u) => {
      if (g.enabled)
        return {
          ...u,
          [g.field.name]: g.filter
        };
      const f = Object.assign({}, u);
      return delete f[g.field.name], f;
    }), value: a[p.name] ? {
      enabled: !0,
      filter: a[p.name],
      field: p,
      required: p.config?.required || !1
    } : {
      enabled: !1,
      field: p,
      filter: qe(p),
      required: !1
    } }, p.name)) }),
    /* @__PURE__ */ s(Ro, { children: [
      /* @__PURE__ */ r(M, { buttonType: "invisible", onClick: () => {
        const p = Go(a);
        l(p), n(p), h();
      }, size: "small", type: "button", children: "Borrar" }),
      /* @__PURE__ */ r(M, { size: "small", type: "submit", children: "Aplicar" })
    ] })
  ] }) }) });
}
const Vo = /* @__PURE__ */ i.button.withConfig({
  displayName: "MenuButton__MenuTrigger",
  componentId: "sc-1azpab4-0"
})(["display:inline-flex;cursor:pointer;background:transparent;justify-content:center;align-items:center;height:32px;width:32px;border:1px solid transparent;border-radius:4px;transition:all 200ms;:focus{box-shadow:0 0 0 4px var(--color-increase-light);outline:0;&::-moz-focus-inner{border:0;}}:hover,:active,:focus:hover{box-shadow:var(--shadow-elevateCast);border:1px solid var(--color-gray-blackLight);path{fill:var(--color-primaryAction-regular);}}svg{", "}"], ({
  verticalIcon: e
}) => e ? "transform: rotate(90deg);" : null), Uo = /* @__PURE__ */ i.div.attrs({
  role: "menu"
}).withConfig({
  displayName: "MenuButton__Menu",
  componentId: "sc-1azpab4-1"
})(["background:var(--color-gray-white);box-shadow:var(--shadow-elevateCast);border:1px solid var(--color-gray-blackLight);border-radius:4px;position:absolute;top:4px;animation:", " 100ms ease-in;min-width:65px;display:flex;flex-direction:column;", ""], J, ({
  position: e
}) => e === "bottomRight" ? `
          text-align: left;
          left: 0;
        ` : `
          text-align: right;
          align-items: flex-end;
          right: -32px;
        `), Ti = /* @__PURE__ */ i.button.attrs({
  role: "menuitem"
}).withConfig({
  displayName: "MenuButton__MenuItem",
  componentId: "sc-1azpab4-2"
})(["", " background:transparent;cursor:pointer;border:none;width:max-content;height:40px;display:inline-flex;align-items:center;padding:10px;", " :not(:disabled):hover{color:", ";}:disabled{opacity:0.36;}"], m("cell"), ({
  variant: e
}) => e === "alert" && "color: var(--color-coralAlert-regular);", ({
  variant: e
}) => e === "alert" ? "var(--color-coralAlert-dark);" : "var(--color-primaryAction-regular);"), Fi = ({
  position: e,
  verticalIcon: t,
  children: o,
  ...n
}) => /* @__PURE__ */ r(A, { renderTrigger: (a, {
  toggleShowMenu: l
}) => /* @__PURE__ */ r(Vo, { "aria-label": "Abrir menú", verticalIcon: t, onClick: l, ...a, children: /* @__PURE__ */ r(vr, {}) }), ...n, children: (a) => /* @__PURE__ */ r(Uo, { position: e, children: o(a) }) }), Yo = /* @__PURE__ */ i.div.withConfig({
  displayName: "ModalHeader__Container",
  componentId: "sc-dik6ps-0"
})(["text-align:", ";"], ({
  align: e
}) => e || "inherit"), Ko = ({
  align: e,
  children: t
}) => /* @__PURE__ */ r(Yo, { align: e, children: /* @__PURE__ */ r(we, { children: t }) }), Xo = {
  left: "flex-start",
  right: "flex-end",
  center: "center"
}, Jo = /* @__PURE__ */ i.div.withConfig({
  displayName: "ModalContent__Container",
  componentId: "sc-18zxavp-0"
})(["", " display:flex;flex-direction:column;justify-content:", ";text-align:", ";overflow-wrap:break-word;&.scrollable{overflow-y:auto;max-height:60vh;}& p{margin:0;}"], m("body"), ({
  align: e
}) => Xo[e || "center"], ({
  align: e
}) => e || "inherit"), Qo = ({
  align: e,
  children: t,
  scrollable: o
}) => /* @__PURE__ */ r(Jo, { align: e, className: o ? "scrollable" : "", children: t }), Zo = {
  left: "flex-start",
  right: "flex-end",
  center: "center"
}, en = /* @__PURE__ */ i.div.withConfig({
  displayName: "ModalFooter__Container",
  componentId: "sc-16ntamy-0"
})(["display:flex;gap:16px;text-align:inherit;justify-content:", ";"], ({
  align: e
}) => Zo[e || "center"]), rn = ({
  align: e,
  children: t
}) => /* @__PURE__ */ r(en, { align: e, children: t }), tn = /* @__PURE__ */ i.div.withConfig({
  displayName: "ModalHeaderIconBox__Wrapper",
  componentId: "sc-aybnb8-0"
})(["margin:-16px;display:flex;justify-content:center;align-items:center;color:white;height:80px;background:", ";position:relative;overflow:hidden;.overlay{background:", ";border-radius:60px;height:270px;width:270px;position:absolute;transform:rotate(45deg);left:calc(-270px / 4);top:-100%;}"], ({
  colorPalette: e,
  theme: t
}) => e === "alert" ? "var(--color-coral-regular)" : `var(--color-${e || t.productName}-dark30)`, ({
  colorPalette: e,
  theme: t
}) => e === "alert" ? "var(--color-coral-medium)" : `var(--color-${e || t.productName}-dark50)`);
function on({
  icon: e,
  colorPalette: t,
  ...o
}) {
  return /* @__PURE__ */ s(tn, { colorPalette: t, ...o, children: [
    /* @__PURE__ */ r("div", { className: "overlay" }),
    /* @__PURE__ */ r("div", { children: e })
  ] });
}
const nn = /* @__PURE__ */ i.div.withConfig({
  displayName: "ModalElements__ModalBody",
  componentId: "sc-hmymn0-0"
})(["display:flex;flex-direction:column;gap:32px;padding:16px;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:", "px;max-width:calc(100vw - 30px);max-height:calc(100vh - 30px);background-color:white;border-radius:3px;color:var(--color-gray-black);text-align:", ";.modal-enter &{opacity:0;transform:translate(-50%,-100%);}.modal-enter-active &{opacity:1;transform:translate(-50%,-50%);transition:opacity 200ms ease-out,transform 200ms ease-out;}.modal-exit &{opacity:1;transform:translate(-50%,-50%);}.modal-exit-active &{opacity:0;transform:translate(-50%,-100%);transition:opacity 200ms ease-out,transform 200ms ease-out;}"], ({
  width: e
}) => e, ({
  align: e
}) => e || "center"), an = /* @__PURE__ */ i.div.withConfig({
  displayName: "ModalElements__ModalWrapper",
  componentId: "sc-hmymn0-1"
})(["position:fixed;top:0;left:0;height:100%;width:100%;z-index:2;overflow:hidden;"]), ln = /* @__PURE__ */ i.div.withConfig({
  displayName: "ModalElements__Shade",
  componentId: "sc-hmymn0-2"
})(["position:absolute;top:0;left:0;height:100%;width:100%;background-color:rgba(0,0,0,0.5);.modal-enter &{opacity:0;}.modal-enter-active &{opacity:1;transition:opacity 200ms ease-out;}.modal-exit &{opacity:1;}.modal-exit-active &{opacity:0;transition:opacity 200ms ease-out;}"]), Re = /* @__PURE__ */ i.button.withConfig({
  displayName: "ModalElements__IconButton",
  componentId: "sc-hmymn0-3"
})(["cursor:pointer;position:absolute;top:9px;right:9px;& svg{fill:var(--color-gray-grayBold);}"]);
function Pe({
  children: e,
  closeOnEscape: t = !0,
  onClose: o,
  shade: n = !0,
  shadeClosable: a = !0,
  visible: l,
  transitionProps: c
}) {
  const d = E(null);
  return /* @__PURE__ */ r(Ie, { selector: "body", children: /* @__PURE__ */ r(_r, { nodeRef: d, classNames: "modal", in: l, mountOnEnter: !0, timeout: 200, unmountOnExit: !0, ...c, children: /* @__PURE__ */ s(an, { ref: d, onClick: (g) => {
    a && o(g);
  }, onKeyUp: (g) => {
    g.key === "Escape" && t && o(g);
  }, children: [
    n && /* @__PURE__ */ r(ln, {}),
    /* @__PURE__ */ r(wr, {}),
    e
  ] }) }) });
}
function cn({
  align: e = "center",
  cancelLabel: t = "Cancelar",
  children: o,
  customFooter: n,
  description: a,
  headerText: l,
  hideCloseButton: c = !1,
  okLabel: d = "Continuar",
  okButtonVariant: h,
  onCancel: p,
  onClose: g,
  onOk: u,
  width: f = "600",
  simple: b,
  icon: v,
  colorPalette: I,
  ...y
}) {
  return /* @__PURE__ */ r(Pe, { ...y, onClose: g, children: /* @__PURE__ */ s(nn, { onClick: ($) => $.stopPropagation(), width: f, children: [
    b ? /* @__PURE__ */ s(C, { children: [
      v && /* @__PURE__ */ r(on, { colorPalette: I, icon: v }),
      l && /* @__PURE__ */ r(Ko, { children: l }),
      /* @__PURE__ */ s(Qo, { align: e, children: [
        a && /* @__PURE__ */ r("p", { children: a }),
        o
      ] }),
      /* @__PURE__ */ r(rn, { align: e, children: n || /* @__PURE__ */ s(C, { children: [
        t && /* @__PURE__ */ r(M, { type: "button", variant: "invisible", onClick: p || g, children: t }),
        u && /* @__PURE__ */ r(M, { type: "button", variant: h, onClick: u, children: d })
      ] }) })
    ] }) : o,
    !c && /* @__PURE__ */ r(Re, { as: "a", onClick: g, children: /* @__PURE__ */ r(U, { size: "24" }) })
  ] }) });
}
const ne = (e) => ({
  ...e,
  props: {
    ...e.props,
    visible: !e.props.visible
  }
}), dn = (e, t) => {
  switch (t.type) {
    case "OPEN_MODAL": {
      const o = ne(t.modal);
      return {
        modals: [...e.modals, o],
        current: o
      };
    }
    case "HIDE_MODAL": {
      const {
        current: o
      } = e;
      if (!o)
        return e;
      const n = ne(o);
      return {
        modals: e.modals.map((a) => a.id === o.id ? o : a),
        current: n
      };
    }
    case "CLOSE_MODAL": {
      const {
        current: o
      } = e;
      return o ? (o.props.onClose?.(), o.props.onCancel?.(), {
        current: null,
        modals: e.modals.filter((a) => a.id !== t.id)
      }) : e;
    }
    default:
      return e;
  }
}, Ge = /* @__PURE__ */ de(void 0), $i = () => {
  const e = ce(Ge);
  if (!e)
    throw new Error("useModal must be used within a ModalProvider");
  return e;
}, Wi = ({
  children: e
}) => {
  const [t, o] = Je(dn, {
    modals: [],
    current: null
  }), n = E(t);
  n.current = t;
  const {
    content: a,
    props: l,
    id: c
  } = n.current.current || {}, d = (u, f = {}) => {
    const b = Date.now();
    return o({
      type: "OPEN_MODAL",
      modal: {
        id: b,
        content: u,
        props: f
      }
    }), b;
  }, h = (u) => {
    o({
      type: "HIDE_MODAL",
      id: u
    });
  }, p = (u) => {
    o({
      type: "CLOSE_MODAL",
      id: u
    });
  }, g = () => {
    const u = n.current.current?.id;
    u && o({
      type: "HIDE_MODAL",
      id: u
    });
  };
  return /* @__PURE__ */ s(Ge.Provider, { value: {
    openModal: d,
    closeModal: h,
    closeCurrentModal: g,
    modals: n.current.modals
  }, children: [
    /* @__PURE__ */ r(cn, { ...l, simple: !0, visible: !!l?.visible, onClose: () => h(c), onCancel: () => h(c), transitionProps: {
      onExited: () => p(c)
    }, children: a }),
    e
  ] });
}, ie = {
  bottom: {
    yfrom: "100%",
    xfrom: "0%"
  },
  top: {
    yfrom: "-100%",
    xfrom: "0%"
  },
  left: {
    xfrom: "-100%",
    yfrom: "0%"
  },
  right: {
    xfrom: "100%",
    yfrom: "0%"
  }
}, sn = /* @__PURE__ */ i.div.withConfig({
  displayName: "Drawer__ModalBody",
  componentId: "sc-xt7b92-0"
})(["--x-from:", ";--y-from:", ";position:absolute;", ";", ";width:", ";height:", ";padding:0.5rem;background-color:white;color:var(--color-gray-black);.modal-enter &{opacity:1;transform:translate(var(--x-from),var(--y-from));}.modal-enter-active &{opacity:1;transform:translate(0%,0%);transition:opacity 200ms ease-out,transform 200ms ease-out;}.modal-exit &{opacity:1;transform:translate(0%,0%);}.modal-exit-active &{opacity:1;transform:translate(var(--x-from),var(--y-from));transition:opacity 200ms ease-out,transform 200ms ease-out;}"], ({
  position: e
}) => ie[e].xfrom, ({
  position: e
}) => ie[e].yfrom, ({
  position: e
}) => e === "right" ? "right: 0" : "left: 0", ({
  position: e
}) => e === "bottom" ? "bottom: 0" : "top: 0", ({
  position: e
}) => ["bottom", "top"].includes(e) ? "100%" : "auto", ({
  position: e
}) => ["left", "right"].includes(e) ? "100%" : "auto");
function Ei({
  children: e,
  onClose: t,
  position: o = "bottom",
  ...n
}) {
  return /* @__PURE__ */ r(Pe, { ...n, onClose: t, children: /* @__PURE__ */ s(sn, { position: o, onClick: (a) => a.stopPropagation(), children: [
    /* @__PURE__ */ r(Re, { as: "a", onClick: t, children: /* @__PURE__ */ r(U, { size: "24" }) }),
    e
  ] }) });
}
const pn = /* @__PURE__ */ V(["0%{transform:translateY(50px);opacity:0;}100%{transform:translateY(0);opacity:1;}"]);
function hn({
  actionText: e,
  bodyText: t,
  cancelText: o,
  className: n,
  type: a = "info",
  onAction: l,
  onCancel: c
}) {
  return /* @__PURE__ */ s("span", { className: n, children: [
    /* @__PURE__ */ r("span", { className: a, children: t }),
    /* @__PURE__ */ s("span", { className: "buttonGroup", children: [
      l && /* @__PURE__ */ r(M, { onClick: l, size: "small", children: e }),
      c && /* @__PURE__ */ r(M, { variant: "invisible", onClick: c, size: "small", children: o })
    ] })
  ] });
}
const Di = /* @__PURE__ */ i(hn).withConfig({
  displayName: "FloatingNotification__FloatingStyled",
  componentId: "sc-15q25ef-0"
})(["background:#ffffff;box-shadow:var(--shadow-rest);border:1px solid rgba(28,28,28,0.15);border-radius:3px;padding:5px 5px 5px 16px;font-size:16px;font-weight:bold;line-height:20px;display:inline-flex;justify-content:space-between;align-items:center;animation:", " 250ms cubic-bezier(0.55,0.06,0.68,0.19);.info{font-weight:normal;}.error{color:var(--color-coral-medium);}.success{color:var(--color-increase-dark30);}span + span{margin-left:16px;}.buttonGroup{button + button{margin-left:4px;}}"], pn), gn = /* @__PURE__ */ i.div.withConfig({
  displayName: "Pagination__Wrapper",
  componentId: "sc-o9tqwt-0"
})(["display:flex;"]), z = /* @__PURE__ */ i.button.withConfig({
  displayName: "Pagination__PageButton",
  componentId: "sc-o9tqwt-1"
})(["", " &:not(:disabled){cursor:pointer;}transition:border 200ms,color 200ms,box-shadow 200ms;display:inline-flex;justify-content:center;align-items:center;width:30px;min-width:max-content;height:30px;padding:0 1px;color:var(--color-gray-blackLight);border-radius:4px;text-align:center;background-color:", ";border:1px solid ", ";:not(:last-child){margin-right:3px;}:focus{box-shadow:0 0 0 2px var(--color-increase-light);border:1px solid var(--color-increase-light50)};outline:0;&::-moz-focus-inner{border:0;}}:not(:disabled):hover{border:1px solid var(--color-gray-subtleBorder);color:var(--color-increase-regular);}:disabled > svg{opacity:0.5;}"], m("cell"), ({
  active: e
}) => e ? "var(--color-increase-light)" : "transparent", ({
  active: e
}) => e ? "var(--color-gray-subtleBorder)" : "transparent"), ae = /* @__PURE__ */ i(z).attrs({
  as: "span",
  children: "..."
}).withConfig({
  displayName: "Pagination__EllipsisButton",
  componentId: "sc-o9tqwt-2"
})(["cursor:default;color:inherit;&:not(:disabled):hover{cursor:default;border:1px solid transparent;color:inherit;}"]), un = (e, t, o = 1) => {
  const n = [];
  for (let a = e; a < t; a += o)
    n.push(a);
  return n;
};
function ji({
  currentPage: e,
  totalPages: t,
  onSelectPage: o,
  ...n
}) {
  let a = e > 2 ? e - 2 : 1;
  const l = Math.min(a + 4, t);
  a = Math.max(l - 4, 1);
  const c = un(a, l + 1);
  return /* @__PURE__ */ s(gn, { ...n, children: [
    /* @__PURE__ */ r(z, { "aria-label": "Anterior", disabled: e === 1, onClick: () => o(e - 1), children: /* @__PURE__ */ r(ue, { size: "24" }) }),
    !c.includes(1) && /* @__PURE__ */ s(C, { children: [
      /* @__PURE__ */ r(z, { active: !1, disabled: !1, onClick: () => o(1), children: 1 }),
      !c.includes(2) && /* @__PURE__ */ r(ae, {})
    ] }),
    c.map((d, h) => /* @__PURE__ */ r(z, { active: d === e, disabled: e === d, onClick: () => o(d), children: d }, h)),
    !c.includes(t) && /* @__PURE__ */ s(C, { children: [
      !c.includes(t - 1) && /* @__PURE__ */ r(ae, {}),
      /* @__PURE__ */ r(z, { active: !1, disabled: !1, onClick: () => o(t), children: t })
    ] }),
    /* @__PURE__ */ r(z, { "aria-label": "Siguiente", disabled: e === t, onClick: () => o(e + 1), children: /* @__PURE__ */ r(me, { size: "24" }) })
  ] });
}
const mn = /* @__PURE__ */ i.div.withConfig({
  displayName: "PathSelector__PathSelectorWrapper",
  componentId: "sc-10ag1ej-0"
})(["position:relative;box-shadow:var(--shadow-rest);border-radius:9px;padding:23px;--shadow-color:var(--color-", "-light);--bg-color:var(--color-", "-regular);:focus-within{box-shadow:0 0 0 4px var(--shadow-color);outline:0;&::-moz-focus-inner{border:0;}}:hover{background:var(--color-gray-white);color:var(--color-increase-dark);box-shadow:var(--shadow-elevate);border:3px solid var(--bg-color);padding:20px;}", " .body{", ";}.title{", ";font-weight:bold;}"], ({
  theme: e
}) => e.productName, ({
  theme: e
}) => e.productName, ({
  checked: e
}) => e ? `
          background: var(--bg-color);
          border: 3px solid var(--bg-color);
          color: var(--color-gray-white);
          padding: 20px;
        ` : `
          background: transparent;
          color: var(--color-gray-blackLight);

          :hover {
            color: var(--color-increase-dark);
            box-shadow: var(--shadow-elevate);
            border: 3px solid var(--bg-color);
            padding: 20px;
          }
        `, ({
  theme: e
}) => e.typography.body, ({
  theme: e
}) => e.typography.body), fn = /* @__PURE__ */ i.input.withConfig({
  displayName: "PathSelector__Input",
  componentId: "sc-10ag1ej-1"
})(["position:absolute;left:0;top:0;margin:0;width:100%;height:100%;opacity:0;cursor:pointer;"]), bn = /* @__PURE__ */ i.div.withConfig({
  displayName: "PathSelector__CheckIconContainer",
  componentId: "sc-10ag1ej-2"
})(["border-radius:100%;background:white;display:flex;justify-content:center;align-items:center;color:var(--color-increase-regular);position:absolute;height:20px;width:20px;top:12px;right:12px;*:hover > &{background:var(--bg-color);color:var(--color-gray-white);}input:not(:checked):not(:hover) ~ &{display:none;}"]);
function Hi({
  className: e,
  title: t,
  children: o,
  htmlTitle: n,
  id: a,
  ...l
}) {
  return /* @__PURE__ */ s(mn, { checked: l.checked, className: e, children: [
    /* @__PURE__ */ r("label", { className: "title", htmlFor: a, children: t }),
    /* @__PURE__ */ r("div", { className: "body", children: o }),
    /* @__PURE__ */ r(fn, { id: a, name: a, type: "radio", ...l }),
    /* @__PURE__ */ r(bn, { children: /* @__PURE__ */ r(H, { size: "18" }) })
  ] });
}
const Ve = /* @__PURE__ */ i.input.attrs({
  type: "radio"
}).withConfig({
  displayName: "RadioButtonControl",
  componentId: "sc-t22odf-0"
})(["margin:0;height:100%;width:100%;opacity:0;cursor:pointer;&:focus{outline:none;}"]), yn = /* @__PURE__ */ i.div.withConfig({
  displayName: "RadioButtonFill",
  componentId: "sc-1v6zulz-0"
})(["background:var(--color-increase-light30);width:calc(100% - 10px);height:calc(100% - 10px);position:absolute;top:5px;left:5px;border-radius:100%;transform:scale(0);pointer-events:none;", ":checked ~ &{transform:scale(1);animation:", " 200ms cubic-bezier(0,0.85,0.81,1.15);}"], Ve, Se), xn = /* @__PURE__ */ i.div.withConfig({
  displayName: "RadioButtonControlWrapper",
  componentId: "sc-bvaunt-0"
})(["height:20px;width:20px;position:relative;margin-right:6px;border-radius:100%;transition:box-shadow 200ms;flex-shrink:0;:focus-within{box-shadow:0 0 0 4px var(--color-increase-light);outline:0;}&::before{content:'';border:2px solid ", ";border-radius:100%;box-sizing:border-box;position:absolute;pointer-events:none;width:100%;height:100%;}"], ({
  checked: e
}) => e ? "var(--color-increase-light30)" : "var(--color-gray-grayMedium)"), vn = /* @__PURE__ */ i.label.withConfig({
  displayName: "RadioButton__RadioButtonWrapper",
  componentId: "sc-z6wqa3-0"
})(["", ";display:", ";flex-direction:row;align-items:center;cursor:pointer;", " ", ";"], ({
  size: e
}) => m(e === "small" ? "cell" : "body"), ({
  inline: e
}) => e ? "inline-flex" : "flex", ({
  inline: e
}) => e && `
      :not(:first-of-type) {
        margin-left: 16px;
      }
    `, ({
  disabled: e
}) => e ? `
            opacity: 0.2;
          ` : `
            &:hover {
              color: var(--color-gray-black);
            }
          `), wn = function({
  checked: e,
  label: t,
  disabled: o,
  name: n,
  inline: a,
  size: l,
  className: c,
  ...d
}) {
  return /* @__PURE__ */ s(vn, { disabled: o, inline: a, size: l, className: c, children: [
    /* @__PURE__ */ s(xn, { checked: e, children: [
      /* @__PURE__ */ r(Ve, { checked: e, disabled: o, name: n, ...d }),
      /* @__PURE__ */ r(yn, {})
    ] }),
    t
  ] });
};
function _n({
  name: e,
  options: t,
  defaultSelected: o
}) {
  const [n, a] = _(o);
  return t.map(({
    label: l,
    value: c
  }) => ({
    label: l,
    name: e,
    value: c,
    onClick: () => a(c),
    checked: n === c
  }));
}
function Oi({
  defaultSelected: e,
  name: t,
  options: o,
  onChange: n,
  inline: a,
  ...l
}) {
  const c = _n({
    name: t,
    options: o,
    defaultSelected: e
  });
  return /* @__PURE__ */ r(k, { ...l, children: ({
    className: d,
    disabled: h,
    required: p,
    style: g,
    title: u
  }) => /* @__PURE__ */ r(C, { children: /* @__PURE__ */ r("fieldset", { style: {
    margin: 0,
    border: "none"
  }, children: c.map((f) => /* @__PURE__ */ r(wn, { ...f, className: d, disabled: h, inline: a, onChange: n, required: p, style: g, title: u }, f.value)) }) }) });
}
const qi = /* @__PURE__ */ i.div.withConfig({
  displayName: "Stepper",
  componentId: "sc-1v0c91x-0"
})([""]), Cn = /* @__PURE__ */ i.div.withConfig({
  displayName: "Stepper__StepperStepWrapper",
  componentId: "sc-1v0c91x-1"
})(["display:flex;height:80px;&.stepper-pending,&.stepper-done{", ",", "{color:var(--color-gray-grayBold);}}"], B, T), R = /* @__PURE__ */ i.div.withConfig({
  displayName: "Stepper__StepperStepIndicatorWrapper",
  componentId: "sc-1v0c91x-2"
})(["width:64px;display:flex;justify-content:center;padding:0 16px;border-left:2px solid ", ";"], ({
  status: e
}) => e === "pending" ? "var(--color-gray-grayBold)" : "var(--color-increase-light30)"), kn = /* @__PURE__ */ i.div.withConfig({
  displayName: "Stepper__GreenCircle",
  componentId: "sc-1v0c91x-3"
})(["margin-top:2px;border-radius:100%;background:var(--color-increase-light30);height:23px;width:23px;"]), In = /* @__PURE__ */ i.div.withConfig({
  displayName: "Stepper__GrayCircumference",
  componentId: "sc-1v0c91x-4"
})(["margin-top:2px;border-radius:100%;border:2px solid #b1b1b1;height:23px;width:23px;"]);
function Nn({
  status: e
}) {
  switch (e) {
    case "current":
      return /* @__PURE__ */ r(R, { status: e, children: /* @__PURE__ */ r(kn, {}) });
    case "pending":
      return /* @__PURE__ */ r(R, { status: e, children: /* @__PURE__ */ r(In, {}) });
    case "done":
      return /* @__PURE__ */ r(R, { status: e, children: /* @__PURE__ */ r(H, { size: "23", color: "#3FBD9B" }) });
  }
}
const Ri = ({
  className: e,
  description: t,
  title: o,
  status: n,
  ...a
}) => /* @__PURE__ */ s(Cn, { className: `${e} stepper-${n}`, ...a, children: [
  /* @__PURE__ */ r(Nn, { status: n }),
  /* @__PURE__ */ s("div", { children: [
    /* @__PURE__ */ r(B, { children: o }),
    /* @__PURE__ */ r(T, { children: t })
  ] })
] }), Mn = /* @__PURE__ */ i.div.withConfig({
  displayName: "Switch__SwitchWrapper",
  componentId: "sc-l44gil-0"
})(["", " display:grid;width:max-content;grid-template-columns:repeat(2,auto);align-items:center;column-gap:8px;"], ({
  size: e
}) => m(e === "small" ? "cell" : "body")), Ue = /* @__PURE__ */ i.input.attrs({
  type: "checkbox"
}).withConfig({
  displayName: "Switch__SwitchControl",
  componentId: "sc-l44gil-1"
})(["height:20px;width:34px;opacity:0;box-sizing:border-box;border:0;margin:0;cursor:", ";"], ({
  disabled: e
}) => e ? "unset" : "pointer"), Sn = /* @__PURE__ */ i.div.withConfig({
  displayName: "Switch__SwitchToggle",
  componentId: "sc-l44gil-2"
})(["height:16px;width:16px;position:absolute;top:1px;left:1px;background-color:", ";border-radius:100%;transition:transform 200ms cubic-bezier(0.4,0,0.2,1);pointer-events:none;", ":checked ~ &{transform:translateX(14px);transition:transform 200ms cubic-bezier(0.4,0,0.2,1);}"], ({
  checked: e
}) => e ? "var(--color-gray-white)" : "var(--color-gray-blackLight)", Ue), Bn = /* @__PURE__ */ i.div.withConfig({
  displayName: "Switch__SwitchControlWrapper",
  componentId: "sc-l44gil-3"
})(["position:relative;height:20px;width:34px;border:1px solid ", ";background-color:", ";border-radius:10px;box-sizing:border-box;margin:1px;transition:all 200ms cubic-bezier(0.4,0,0.2,1);opacity:", ";transition:all 200ms;:focus-within{box-shadow:0 0 0 4px var(--color-increase-light);outline:0;}"], ({
  checked: e
}) => e ? "var(--color-increase-light30)" : "var(--color-gray-subtleBorder)", ({
  checked: e
}) => e ? "var(--color-increase-light30)" : "var(--color-gray-grayBold)", ({
  disabled: e
}) => e ? 0.36 : 1);
function An({
  className: e,
  checked: t,
  id: o,
  name: n,
  label: a,
  labelHidden: l,
  size: c,
  onChange: d,
  disabled: h,
  ...p
}) {
  return /* @__PURE__ */ s(Mn, { size: c, className: e, children: [
    /* @__PURE__ */ s(Bn, { checked: t, disabled: h, children: [
      /* @__PURE__ */ r(Ue, { "aria-label": a, checked: t, disabled: h, id: o, name: n, onChange: h ? void 0 : d, title: l ? a : void 0, ...p }),
      /* @__PURE__ */ r(Sn, { checked: t })
    ] }),
    !l && /* @__PURE__ */ r("label", { htmlFor: o, children: a })
  ] });
}
const Pi = /* @__PURE__ */ i.div.withConfig({
  displayName: "Table__TableWrapper",
  componentId: "sc-15opere-0"
})(["background:white;border:1px solid var(--color-gray-grayMedium);border-radius:9px;padding:20px;flex:1;"]), Gi = /* @__PURE__ */ i.div.withConfig({
  displayName: "Table__TableHeader",
  componentId: "sc-15opere-1"
})(["margin-bottom:16px;display:flex;justify-content:space-between;align-items:baseline;"]), Vi = {
  double: "double",
  border: "border"
}, zn = {
  rightAligned: "rightAligned",
  ellipsis: "ellipsis"
}, Ui = zn, Ln = /* @__PURE__ */ i.table.withConfig({
  displayName: "Table__StyledTable",
  componentId: "sc-15opere-2"
})(["border-collapse:collapse;border-spacing:0;width:100%;font-size:13px;line-height:16px;", " ", " td{vertical-align:middle;padding:0 8px;}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}.rightAligned{text-align:right;}.border{border-bottom:1px solid var(--color-gray-grayMedium);}tr{height:40px;position:relative;}tr.double{height:58px;}thead{border-bottom:3px solid var(--color-gray-black);}th{", ";text-align:left;font-weight:500;height:42px;vertical-align:middle;padding:8px;text-transform:uppercase;}"], ({
  fixedLayout: e
}) => e && "table-layout: fixed;", ({
  zebra: e
}) => e && `
      tr:nth-child(even) {
        background: var(--color-gray-grayLight);
      }
      tr {
        border-bottom: none;
      }
    `, m("label")), Tn = /* @__PURE__ */ i($r).withConfig({
  displayName: "Table__NoDataLabel",
  componentId: "sc-15opere-3"
})(["color:var(--color-gray-grayBold);margin-top:'8px';"]), Fn = ({
  noDataMessage: e = "No hay datos"
}) => /* @__PURE__ */ s("div", { style: {
  display: "inline-flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  margin: "16px 0 0"
}, children: [
  /* @__PURE__ */ r(or, { height: "96", width: "96" }),
  /* @__PURE__ */ r(Tn, { children: e })
] }), Yi = ({
  children: e,
  zebra: t,
  hasData: o,
  fixedLayout: n,
  noDataMessage: a,
  ...l
}) => /* @__PURE__ */ s(C, { children: [
  /* @__PURE__ */ r(Ln, { ...l, fixedLayout: n, zebra: t, children: e }),
  o === !1 && /* @__PURE__ */ r(Fn, { noDataMessage: a })
] }), ee = (e) => {
  let t = "";
  for (const o in e)
    Object.prototype.hasOwnProperty.call(e, o) && e[o] && (t += ` ${o}`);
  return t;
}, Ki = /* @__PURE__ */ i.thead.withConfig({
  displayName: "TablePrimitives__THead",
  componentId: "sc-e87uay-0"
})([""]), $n = /* @__PURE__ */ i.th.withConfig({
  displayName: "TablePrimitives__TH",
  componentId: "sc-e87uay-1"
})(["", ""], ({
  width: e
}) => e && `width: ${e};`);
function Xi({
  children: e,
  width: t,
  ...o
}) {
  const n = ee(o);
  return /* @__PURE__ */ r($n, { className: n, width: t, children: e });
}
function Ji({
  children: e,
  style: t,
  ...o
}) {
  const n = ee(o);
  return /* @__PURE__ */ r("tr", { className: n, style: t, children: e });
}
function Qi({
  children: e,
  style: t,
  ...o
}) {
  const n = ee(o);
  return /* @__PURE__ */ r("td", { className: n, style: t, children: e });
}
function W(e, t) {
  return typeof e != "function" ? e : e(t);
}
const Wn = /* @__PURE__ */ i.div.withConfig({
  displayName: "Tag__TagWrapper",
  componentId: "sc-118dh7d-0"
})(["", " display:flex;gap:4px;align-items:center;border:1px solid ", ";color:", ";background-color:", ";height:20px;padding:0 9px;border-radius:10px;font-weight:", ";width:max-content;"], m("label"), ({
  colors: e,
  theme: t
}) => W(e.border, t) || W(e.background, t), ({
  colors: e,
  theme: t
}) => W(e.foreground, t) || "var(--color-gray-white)", ({
  colors: e,
  theme: t
}) => W(e.background, t), ({
  weight: e
}) => e || "500"), Ye = /* @__PURE__ */ i.div.withConfig({
  displayName: "Tag__IconWrapper",
  componentId: "sc-118dh7d-1"
})(["display:flex;align-items:center;justify-content:center;color:", ";svg{height:1em;width:1em;}"], ({
  colors: e,
  theme: t
}) => W(e.foreground, t) || "var(--color-gray-white)"), En = /* @__PURE__ */ i(Ye).attrs({
  as: "button"
}).withConfig({
  displayName: "Tag__IconButton",
  componentId: "sc-118dh7d-2"
})(["background:transparent;border:none;cursor:pointer;padding:0;&:hover svg{fill:var(--color-coralAlert-regular);}"]);
function Zi({
  children: e,
  icon: t,
  colors: o,
  onClose: n,
  ...a
}) {
  return /* @__PURE__ */ s(Wn, { colors: o, icon: t, ...a, children: [
    t && /* @__PURE__ */ r(Ye, { colors: o, children: t }),
    /* @__PURE__ */ r("span", { children: e }),
    n && /* @__PURE__ */ r(En, { as: "button", colors: o, onClick: n, children: /* @__PURE__ */ r(U, {}) })
  ] });
}
const Dn = /* @__PURE__ */ i.div.withConfig({
  displayName: "ToggleCard__Wrapper",
  componentId: "sc-q7cxio-0"
})(["background:var(--color-gray-graySLight);border:1px solid var(--color-gray-grayMedium);box-sizing:border-box;border-radius:9px;display:flex;flex-direction:column;"]), jn = /* @__PURE__ */ i.div.withConfig({
  displayName: "ToggleCard__Footer",
  componentId: "sc-q7cxio-1"
})(["background:", ";border-bottom-left-radius:9px;border-bottom-right-radius:9px;padding:16px;display:flex;justify-content:space-between;align-items:center;"], ({
  checked: e
}) => e ? "var(--color-increase-light)" : "var(--color-gray-grayLight)"), Hn = /* @__PURE__ */ i.div.withConfig({
  displayName: "ToggleCard__Body",
  componentId: "sc-q7cxio-2"
})(["", " padding:16px;flex:1;"], ({
  theme: e
}) => e.typography.cell);
function ea({
  className: e,
  id: t,
  title: o,
  children: n,
  statusText: a,
  checked: l,
  ...c
}) {
  return /* @__PURE__ */ s(Dn, { className: e, children: [
    /* @__PURE__ */ s(Hn, { children: [
      /* @__PURE__ */ r(T, { style: {
        marginBottom: "8px"
      }, children: o }),
      n
    ] }),
    /* @__PURE__ */ s(jn, { checked: l, children: [
      /* @__PURE__ */ r(X, { htmlFor: t, weight: "bold", children: a }),
      /* @__PURE__ */ r(An, { checked: l, id: t, label: a, labelHidden: !0, name: t, ...c })
    ] })
  ] });
}
export {
  vi as ApplicationLayout,
  Bt as BaseButton,
  _e as BasicLink,
  M as Button,
  _i as ButtonMenu,
  zt as ButtonMenuButton,
  wi as ButtonMenuItem,
  xi as Caption,
  K as CellText,
  Wt as Checkbox,
  Ae as CheckboxInput,
  Be as CheckboxInputControl,
  Ft as CheckboxInputFill,
  Ci as ContentCard,
  ki as Currency,
  ao as DateInput,
  so as DateRangeInput,
  Le as Datepicker,
  Ei as Drawer,
  Li as FilterButton,
  Wo as FilterInput,
  A as FloatingMenu,
  Di as FloatingNotification,
  D as Grid,
  fi as H1,
  we as H2,
  T as H3,
  yi as InlineText,
  k as InputBase,
  Mi as InputFile,
  X as InputLabel,
  q as InputNumber,
  Ii as InputPassword,
  ze as InputSearch,
  Pt as InputText,
  $r as Label,
  qt as LabelError,
  L as Link,
  Fi as MenuButton,
  Ti as MenuItem,
  cn as Modal,
  Qo as ModalContent,
  rn as ModalFooter,
  Ko as ModalHeader,
  on as ModalHeaderIconBox,
  Wi as ModalsProvider,
  Q as NativeSelect,
  vt as OnTopNotification,
  ji as Pagination,
  B as Paragraph,
  Hi as PathSelector,
  wn as RadioButton,
  Oi as RadioGroup,
  So as Select,
  Ai as SelectBox,
  He as SelectBoxContent,
  zi as SelectBoxMultiple,
  Oe as SelectBoxMultipleContent,
  Ao as SelectMultiple,
  Si as SelectOptGroup,
  Bi as SelectOption,
  St as Spinner,
  qi as Stepper,
  Ri as StepperStep,
  bi as SuperHeader,
  An as Switch,
  Ki as THead,
  Yi as Table,
  Gi as TableHeader,
  Ji as TableRow,
  Pi as TableWrapper,
  Zi as Tag,
  Qi as Td,
  zn as TdClasses,
  Ni as TextArea,
  Xi as Th,
  Ui as ThClasses,
  ui as ThemeProvider,
  ea as ToggleCard,
  Vi as TrClasses,
  Ie as UniversalPortal,
  pt as VerticalNavigation,
  oe as VerticalNavigationElement,
  mi as color,
  m as typography,
  $i as useModal,
  ke as useOnClickOutside,
  _n as useRadioButton
};
